import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, unref as _unref, resolveComponent as _resolveComponent, createVNode as _createVNode, toDisplayString as _toDisplayString, withCtx as _withCtx, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass } from "vue"

const _hoisted_1 = { class: "title-header" }
const _hoisted_2 = { class: "dashboard-body mtop-04" }
const _hoisted_3 = { class: "main-grid" }
const _hoisted_4 = { class: "section-label" }
const _hoisted_5 = { class: "data-subgrid data-subgrid-refraction" }
const _hoisted_6 = { class: "data-subgrid data-subgrid-refraction" }
const _hoisted_7 = { class: "row-end w-full" }
const _hoisted_8 = { class: "item-m mleft-03" }
const _hoisted_9 = { class: "data-subgrid data-subgrid-refraction" }
const _hoisted_10 = { class: "input-cell" }
const _hoisted_11 = { class: "input-cell" }
const _hoisted_12 = { class: "input-cell" }
const _hoisted_13 = { class: "input-cell" }
const _hoisted_14 = { class: "input-cell" }
const _hoisted_15 = { class: "input-cell" }
const _hoisted_16 = { class: "data-subgrid data-subgrid-refraction" }
const _hoisted_17 = { class: "input-cell" }
const _hoisted_18 = { class: "input-cell" }
const _hoisted_19 = { class: "input-cell" }
const _hoisted_20 = { class: "input-cell" }
const _hoisted_21 = { class: "input-cell" }
const _hoisted_22 = { class: "input-cell" }
const _hoisted_23 = { class: "row-end w-full" }
const _hoisted_24 = { class: "item-m mleft-03" }
const _hoisted_25 = { class: "data-subgrid data-subgrid-refraction" }
const _hoisted_26 = { class: "input-cell" }
const _hoisted_27 = { class: "input-cell" }
const _hoisted_28 = { class: "input-cell" }
const _hoisted_29 = { class: "input-cell" }
const _hoisted_30 = { class: "input-cell" }
const _hoisted_31 = { class: "input-cell" }
const _hoisted_32 = { class: "data-subgrid data-subgrid-refraction" }
const _hoisted_33 = { class: "input-cell" }
const _hoisted_34 = { class: "input-cell" }
const _hoisted_35 = { class: "input-cell" }
const _hoisted_36 = { class: "input-cell" }
const _hoisted_37 = { class: "input-cell" }
const _hoisted_38 = { class: "input-cell" }
const _hoisted_39 = { class: "row w-full" }
const _hoisted_40 = { class: "item-m" }
const _hoisted_41 = { class: "item-m mleft-03" }
const _hoisted_42 = { class: "data-subgrid data-subgrid-refraction" }
const _hoisted_43 = { class: "input-cell" }
const _hoisted_44 = { class: "input-cell" }
const _hoisted_45 = { class: "input-cell" }
const _hoisted_46 = { class: "input-cell" }
const _hoisted_47 = { class: "input-cell" }
const _hoisted_48 = { class: "input-cell" }
const _hoisted_49 = { class: "data-subgrid data-subgrid-refraction" }
const _hoisted_50 = { class: "input-cell" }
const _hoisted_51 = { class: "input-cell" }
const _hoisted_52 = { class: "input-cell" }
const _hoisted_53 = { class: "input-cell" }
const _hoisted_54 = { class: "input-cell" }
const _hoisted_55 = { class: "input-cell" }
const _hoisted_56 = { class: "row-label" }
const _hoisted_57 = { class: "data-subgrid data-subgrid-refraction" }
const _hoisted_58 = { class: "input-cell" }
const _hoisted_59 = { class: "input-cell" }
const _hoisted_60 = { class: "input-cell" }
const _hoisted_61 = { class: "input-cell" }
const _hoisted_62 = { class: "input-cell" }
const _hoisted_63 = { class: "input-cell" }
const _hoisted_64 = { class: "data-subgrid data-subgrid-refraction" }
const _hoisted_65 = { class: "input-cell" }
const _hoisted_66 = { class: "input-cell" }
const _hoisted_67 = { class: "input-cell" }
const _hoisted_68 = { class: "input-cell" }
const _hoisted_69 = { class: "input-cell" }
const _hoisted_70 = { class: "input-cell" }
const _hoisted_71 = { class: "action-buttons-row row gap-04 mtop-02" }
const _hoisted_72 = { class: "bg-modal w-maxC" }
const _hoisted_73 = { class: "bg-modal w-maxC" }
const _hoisted_74 = { class: "row-end w-full" }
const _hoisted_75 = { class: "item-m mleft-03" }
const _hoisted_76 = { class: "data-subgrid data-subgrid-kerato" }
const _hoisted_77 = { class: "data-subgrid data-subgrid-kerato" }
const _hoisted_78 = { class: "row-label" }
const _hoisted_79 = { class: "data-subgrid data-subgrid-kerato" }
const _hoisted_80 = { class: "data-subgrid data-subgrid-kerato" }
const _hoisted_81 = { class: "row-label" }
const _hoisted_82 = { class: "data-subgrid data-subgrid-kerato" }
const _hoisted_83 = { class: "data-subgrid data-subgrid-kerato" }
const _hoisted_84 = { class: "row-end w-full" }
const _hoisted_85 = { class: "item-m mleft-03" }
const _hoisted_86 = { class: "data-subgrid data-subgrid-single" }
const _hoisted_87 = { class: "input-cell" }
const _hoisted_88 = { class: "data-subgrid data-subgrid-single" }
const _hoisted_89 = { class: "input-cell" }
const _hoisted_90 = { class: "section-label" }
const _hoisted_91 = { class: "data-subgrid data-subgrid-single" }
const _hoisted_92 = { class: "input-cell" }
const _hoisted_93 = { class: "data-subgrid data-subgrid-single" }
const _hoisted_94 = { class: "input-cell" }
const _hoisted_95 = { class: "section-label" }
const _hoisted_96 = { class: "data-subgrid data-subgrid-single" }
const _hoisted_97 = { class: "input-cell" }
const _hoisted_98 = { class: "data-subgrid data-subgrid-single" }
const _hoisted_99 = { class: "input-cell" }
const _hoisted_100 = { class: "image-subgrid" }
const _hoisted_101 = { class: "rowcenter w-full" }
const _hoisted_102 = { class: "bg-modal w-maxC history-dropdown-menu" }
const _hoisted_103 = {
  key: 0,
  class: "no-history-msg"
}
const _hoisted_104 = { class: "rowcenter w-full" }
const _hoisted_105 = { class: "item-m mleft-03" }
const _hoisted_106 = { class: "image-subgrid" }
const _hoisted_107 = { class: "rowcenter w-full" }
const _hoisted_108 = { class: "item-m mleft-03" }
const _hoisted_109 = { class: "rowcenter w-full" }
const _hoisted_110 = { class: "bg-modal w-maxC history-dropdown-menu" }
const _hoisted_111 = {
  key: 0,
  class: "no-history-msg"
}
const _hoisted_112 = { class: "section-label" }
const _hoisted_113 = { class: "image-subgrid" }
const _hoisted_114 = ["src", "alt"]
const _hoisted_115 = {
  key: 1,
  class: "placeholder-text"
}
const _hoisted_116 = ["src", "alt"]
const _hoisted_117 = {
  key: 1,
  class: "placeholder-text"
}
const _hoisted_118 = { class: "image-subgrid" }
const _hoisted_119 = ["src", "alt"]
const _hoisted_120 = {
  key: 1,
  class: "placeholder-text"
}
const _hoisted_121 = ["src", "alt"]
const _hoisted_122 = {
  key: 1,
  class: "placeholder-text"
}
const _hoisted_123 = { class: "data-subgrid data-subgrid-single fundus-notes-spacing" }
const _hoisted_124 = { class: "input-cell" }
const _hoisted_125 = { class: "data-subgrid data-subgrid-single fundus-notes-spacing" }
const _hoisted_126 = { class: "input-cell" }
const _hoisted_127 = { class: "oct-both-header-area" }
const _hoisted_128 = { class: "oct-triple-subgrid" }
const _hoisted_129 = { class: "rowcenter w-full" }
const _hoisted_130 = { class: "bg-modal w-maxC history-dropdown-menu" }
const _hoisted_131 = {
  key: 0,
  class: "no-history-msg"
}
const _hoisted_132 = { class: "rowcenter w-full" }
const _hoisted_133 = { class: "item-m mleft-03" }
const _hoisted_134 = { class: "rowcenter w-full" }
const _hoisted_135 = { class: "bg-modal w-maxC history-dropdown-menu" }
const _hoisted_136 = {
  key: 0,
  class: "no-history-msg"
}
const _hoisted_137 = { class: "section-label" }
const _hoisted_138 = { class: "oct-both-header-area" }
const _hoisted_139 = { class: "oct-triple-subgrid" }
const _hoisted_140 = ["src", "alt"]
const _hoisted_141 = {
  key: 1,
  class: "placeholder-text"
}
const _hoisted_142 = ["src", "alt"]
const _hoisted_143 = {
  key: 1,
  class: "placeholder-text"
}
const _hoisted_144 = ["src", "alt"]
const _hoisted_145 = {
  key: 1,
  class: "placeholder-text"
}
const _hoisted_146 = { class: "image-subgrid" }
const _hoisted_147 = { class: "rowcenter w-full" }
const _hoisted_148 = { class: "bg-modal w-maxC history-dropdown-menu" }
const _hoisted_149 = {
  key: 0,
  class: "no-history-msg"
}
const _hoisted_150 = { class: "rowcenter w-full" }
const _hoisted_151 = { class: "item-m mleft-03" }
const _hoisted_152 = { class: "rowcenter w-full" }
const _hoisted_153 = { class: "item-m mleft-03" }
const _hoisted_154 = { class: "image-subgrid" }
const _hoisted_155 = { class: "rowcenter w-full" }
const _hoisted_156 = { class: "item-m mleft-03" }
const _hoisted_157 = { class: "rowcenter w-full" }
const _hoisted_158 = { class: "bg-modal w-maxC history-dropdown-menu" }
const _hoisted_159 = {
  key: 0,
  class: "no-history-msg"
}
const _hoisted_160 = { class: "section-label" }
const _hoisted_161 = { class: "image-subgrid" }
const _hoisted_162 = ["src", "alt"]
const _hoisted_163 = {
  key: 1,
  class: "placeholder-text"
}
const _hoisted_164 = ["src", "alt"]
const _hoisted_165 = {
  key: 1,
  class: "placeholder-text"
}
const _hoisted_166 = { class: "image-subgrid" }
const _hoisted_167 = ["src", "alt"]
const _hoisted_168 = {
  key: 1,
  class: "placeholder-text"
}
const _hoisted_169 = ["src", "alt"]
const _hoisted_170 = {
  key: 1,
  class: "placeholder-text"
}
const _hoisted_171 = { class: "image-subgrid" }
const _hoisted_172 = { class: "rowcenter w-full" }
const _hoisted_173 = { class: "bg-modal w-maxC history-dropdown-menu" }
const _hoisted_174 = {
  key: 0,
  class: "no-history-msg"
}
const _hoisted_175 = { class: "rowcenter w-full" }
const _hoisted_176 = { class: "item-m mleft-03" }
const _hoisted_177 = { class: "image-subgrid" }
const _hoisted_178 = { class: "rowcenter w-full" }
const _hoisted_179 = { class: "item-m mleft-03" }
const _hoisted_180 = { class: "rowcenter w-full" }
const _hoisted_181 = { class: "bg-modal w-maxC history-dropdown-menu" }
const _hoisted_182 = {
  key: 0,
  class: "no-history-msg"
}
const _hoisted_183 = { class: "section-label" }
const _hoisted_184 = { class: "image-subgrid" }
const _hoisted_185 = ["src", "alt"]
const _hoisted_186 = {
  key: 1,
  class: "placeholder-text"
}
const _hoisted_187 = ["src", "alt"]
const _hoisted_188 = {
  key: 1,
  class: "placeholder-text"
}
const _hoisted_189 = { class: "image-subgrid" }
const _hoisted_190 = ["src", "alt"]
const _hoisted_191 = {
  key: 1,
  class: "placeholder-text"
}
const _hoisted_192 = ["src", "alt"]
const _hoisted_193 = {
  key: 1,
  class: "placeholder-text"
}
const _hoisted_194 = { class: "image-subgrid" }
const _hoisted_195 = { class: "rowcenter w-full" }
const _hoisted_196 = { class: "bg-modal w-maxC history-dropdown-menu" }
const _hoisted_197 = {
  key: 0,
  class: "no-history-msg"
}
const _hoisted_198 = { class: "rowcenter w-full" }
const _hoisted_199 = { class: "item-m mleft-03" }
const _hoisted_200 = { class: "image-subgrid" }
const _hoisted_201 = { class: "rowcenter w-full" }
const _hoisted_202 = { class: "item-m mleft-03" }
const _hoisted_203 = { class: "rowcenter w-full" }
const _hoisted_204 = { class: "bg-modal w-maxC history-dropdown-menu" }
const _hoisted_205 = {
  key: 0,
  class: "no-history-msg"
}
const _hoisted_206 = { class: "section-label" }
const _hoisted_207 = { class: "image-subgrid" }
const _hoisted_208 = ["src", "alt"]
const _hoisted_209 = {
  key: 1,
  class: "placeholder-text"
}
const _hoisted_210 = ["src", "alt"]
const _hoisted_211 = {
  key: 1,
  class: "placeholder-text"
}
const _hoisted_212 = { class: "image-subgrid" }
const _hoisted_213 = ["src", "alt"]
const _hoisted_214 = {
  key: 1,
  class: "placeholder-text"
}
const _hoisted_215 = ["src", "alt"]
const _hoisted_216 = {
  key: 1,
  class: "placeholder-text"
}
const _hoisted_217 = { class: "image-subgrid" }
const _hoisted_218 = { class: "rowcenter w-full" }
const _hoisted_219 = { class: "bg-modal w-maxC history-dropdown-menu" }
const _hoisted_220 = {
  key: 0,
  class: "no-history-msg"
}
const _hoisted_221 = { class: "rowcenter w-full" }
const _hoisted_222 = { class: "item-m mleft-03" }
const _hoisted_223 = { class: "image-subgrid" }
const _hoisted_224 = { class: "rowcenter w-full" }
const _hoisted_225 = { class: "item-m mleft-03" }
const _hoisted_226 = { class: "rowcenter w-full" }
const _hoisted_227 = { class: "bg-modal w-maxC history-dropdown-menu" }
const _hoisted_228 = {
  key: 0,
  class: "no-history-msg"
}
const _hoisted_229 = { class: "section-label" }
const _hoisted_230 = { class: "image-subgrid" }
const _hoisted_231 = ["src", "alt"]
const _hoisted_232 = {
  key: 1,
  class: "placeholder-text"
}
const _hoisted_233 = ["src", "alt"]
const _hoisted_234 = {
  key: 1,
  class: "placeholder-text"
}
const _hoisted_235 = { class: "image-subgrid" }
const _hoisted_236 = ["src", "alt"]
const _hoisted_237 = {
  key: 1,
  class: "placeholder-text"
}
const _hoisted_238 = ["src", "alt"]
const _hoisted_239 = {
  key: 1,
  class: "placeholder-text"
}
const _hoisted_240 = { class: "image-subgrid" }
const _hoisted_241 = { class: "rowcenter w-full" }
const _hoisted_242 = { class: "bg-modal w-maxC history-dropdown-menu" }
const _hoisted_243 = {
  key: 0,
  class: "no-history-msg"
}
const _hoisted_244 = { class: "rowcenter w-full" }
const _hoisted_245 = { class: "item-m mleft-03" }
const _hoisted_246 = { class: "image-subgrid" }
const _hoisted_247 = { class: "rowcenter w-full" }
const _hoisted_248 = { class: "item-m mleft-03" }
const _hoisted_249 = { class: "rowcenter w-full" }
const _hoisted_250 = { class: "bg-modal w-maxC history-dropdown-menu" }
const _hoisted_251 = {
  key: 0,
  class: "no-history-msg"
}
const _hoisted_252 = { class: "section-label" }
const _hoisted_253 = { class: "image-subgrid" }
const _hoisted_254 = ["src", "alt"]
const _hoisted_255 = {
  key: 1,
  class: "placeholder-text"
}
const _hoisted_256 = ["src", "alt"]
const _hoisted_257 = {
  key: 1,
  class: "placeholder-text"
}
const _hoisted_258 = { class: "image-subgrid" }
const _hoisted_259 = ["src", "alt"]
const _hoisted_260 = {
  key: 1,
  class: "placeholder-text"
}
const _hoisted_261 = ["src", "alt"]
const _hoisted_262 = {
  key: 1,
  class: "placeholder-text"
}

import imageViewerModal from '@/components/imageViewerModal.vue';

import { ref, onMounted, onBeforeUnmount, watch, nextTick } from 'vue';
import { useI18n } from "vue-i18n";
import { useRoute } from 'vue-router';
import { useDebounceFn } from '@vueuse/core';
import patientapi from "@/api/patientapi"
import { useCurrentEntryStore } from '@/stores/currentEntry';
import { useUiStore } from '@/stores/ui';
import gen from "@/functions/general.js"
import { toastError, toastSuccess } from "@/utils/toast-utils";
import { useToast } from "primevue";

type SectionKey = keyof typeof WRITE_FIELD_MAPPING;
type EyeKey = 'right' | 'left';

// ============================================
// DEBOUNCED FIELD UPDATE
// ============================================

type PendingChanges = Record<string, Record<string, string>>;
type RefractionRef = ReturnType<typeof createRefractionRef>;

interface HistoryItem {
  expression_CclId: string;
  fileId: string;
  date: string;
}

interface ImageData {
  url: string;
  alt: string;
  label?: string;
}


export default /*@__PURE__*/_defineComponent({
  __name: 'dashbOphtalmo',
  setup(__props) {

const toast = useToast();
const uiStore = useUiStore()
const currentEntryStore = useCurrentEntryStore();
const route = useRoute();
const { t } = useI18n();

const dashbData = ref(null);
const dropd = ref("");

// Flag to prevent saving during initial data load
const isInitialLoad = ref(true);

// Input values
const slitLampRightEye = ref("");
const slitLampLeftEye = ref("");

const iopRightEye = ref("");
const iopLeftEye = ref("");

const pachymetryRightEye = ref("");
const pachymetryLeftEye = ref("");

// Fundus notes
const fundusRightEye = ref("");
const fundusLeftEye = ref("");

// Factory function for refraction refs
const createRefractionRef = () => ref({
  sphere: "",
  cylinder: "",
  axis: "",
  add: "",
  va: "",
  nva: ""
});

// Refraction - Glasses (editable)
const glassesRight = createRefractionRef();
const glassesLeft = createRefractionRef();

// Refraction - Objective (editable)
const objectiveRight = createRefractionRef();
const objectiveLeft = createRefractionRef();

// Refraction - Subjective (editable)
const subjectiveRight = createRefractionRef();
const subjectiveLeft = createRefractionRef();

// Refraction - Final (editable)
const finalRefractionRight = createRefractionRef();
const finalRefractionLeft = createRefractionRef();

// ============================================
// WRITE FIELD MAPPING (for saving to backend)
// ============================================

const WRITE_FIELD_MAPPING = {
  glasses: {
    measurementType: 'LENSMETER',
    right: {
      sphere: 'SPHERE_RIGHT_LENSMETER',
      cylinder: 'CYLINDER_RIGHT_LENSMETER',
      axis: 'AXIS_RIGHT_LENSMETER',
      add: 'ADD_RIGHT_LENSMETER',
      va: 'VISUAL_ACUITY_RIGHT_LENSMETER',
      nva: 'NEAR_VISUAL_ACUITY_RIGHT_LENSMETER',
    },
    left: {
      sphere: 'SPHERE_LEFT_LENSMETER',
      cylinder: 'CYLINDER_LEFT_LENSMETER',
      axis: 'AXIS_LEFT_LENSMETER',
      add: 'ADD_LEFT_LENSMETER',
      va: 'VISUAL_ACUITY_LEFT_LENSMETER',
      nva: 'NEAR_VISUAL_ACUITY_LEFT_LENSMETER',
    },
  },
  objective: {
    measurementType: 'TONOMETER',
    right: {
      sphere: 'SPHERE_RIGHT_OBJECTIVE',
      cylinder: 'CYLINDER_RIGHT_OBJECTIVE',
      axis: 'AXIS_RIGHT_OBJECTIVE',
      add: 'ADD_RIGHT_OBJECTIVE',
      va: 'VISUAL_ACUITY_RIGHT_OBJECTIVE',
      nva: 'NEAR_VISUAL_ACUITY_RIGHT_OBJECTIVE',
    },
    left: {
      sphere: 'SPHERE_LEFT_OBJECTIVE',
      cylinder: 'CYLINDER_LEFT_OBJECTIVE',
      axis: 'AXIS_LEFT_OBJECTIVE',
      add: 'ADD_LEFT_OBJECTIVE',
      va: 'VISUAL_ACUITY_LEFT_OBJECTIVE',
      nva: 'NEAR_VISUAL_ACUITY_LEFT_OBJECTIVE',
    },
  },
  subjective: {
    measurementType: 'REFRACTION',
    right: {
      sphere: 'SPHERE_RIGHT_SUBJECTIVE',
      cylinder: 'CYLINDER_RIGHT_SUBJECTIVE',
      axis: 'AXIS_RIGHT_SUBJECTIVE',
      add: 'ADD_RIGHT_SUBJECTIVE',
      va: 'VISUAL_ACUITY_RIGHT_SUBJECTIVE',
      nva: 'NEAR_VISUAL_ACUITY_RIGHT_SUBJECTIVE',
    },
    left: {
      sphere: 'SPHERE_LEFT_SUBJECTIVE',
      cylinder: 'CYLINDER_LEFT_SUBJECTIVE',
      axis: 'AXIS_LEFT_SUBJECTIVE',
      add: 'ADD_LEFT_SUBJECTIVE',
      va: 'VISUAL_ACUITY_LEFT_SUBJECTIVE',
      nva: 'NEAR_VISUAL_ACUITY_LEFT_SUBJECTIVE',
    },
  },
  finalRefraction: {
    measurementType: 'REFRACTION',
    right: {
      sphere: 'SPHERE_RIGHT_FINAL',
      cylinder: 'CYLINDER_RIGHT_FINAL',
      axis: 'AXIS_RIGHT_FINAL',
      add: 'ADD_RIGHT_FINAL',
      va: 'VISUAL_ACUITY_RIGHT_FINAL',
      nva: 'NEAR_VISUAL_ACUITY_RIGHT_FINAL',
    },
    left: {
      sphere: 'SPHERE_LEFT_FINAL',
      cylinder: 'CYLINDER_LEFT_FINAL',
      axis: 'AXIS_LEFT_FINAL',
      add: 'ADD_LEFT_FINAL',
      va: 'VISUAL_ACUITY_LEFT_FINAL',
      nva: 'NEAR_VISUAL_ACUITY_LEFT_FINAL',
    },
  },
  iop: {
    measurementType: 'TONOMETER',
    right: { value: 'IOP_RIGHT' },
    left: { value: 'IOP_LEFT' },
  },
  pachymetry: {
    measurementType: 'TONOMETER',
    right: { value: 'PACHYMETRY_RIGHT' },
    left: { value: 'PACHYMETRY_LEFT' },
  },
  slitLamp: {
    measurementType: 'SLIT_LAMP',
    right: { findings: 'SLIT_LAMP_RIGHT' },
    left: { findings: 'SLIT_LAMP_LEFT' },
  },
  fundus: {
    measurementType: 'FUNDUS',
    right: { findings: 'FUNDUS_FINDINGS_RIGHT' },
    left: { findings: 'FUNDUS_FINDINGS_LEFT' },
  },  
} as const;

async function updateOphthalmicField(snapshot: PendingChanges) {
  for (const [measurementType, fields] of Object.entries(snapshot)) {
    try {
      const patientId = route.params.patientId as string;

      await patientapi.updateOphthalmicFields(
          patientId,
          measurementType,
          fields
      );
    } catch (error) {
      console.error('Failed to update field:', error);
      toastError(toast, {
        summary: t('common.toast.error'),
        detail: t('error.DEFAULT')
      });
    }
  }
}

const debouncedFlush = useDebounceFn(flush, 700);

const pending: PendingChanges = {};

function queueRefractionChange(
    section: SectionKey,
    eye: EyeKey,
    field: string,
    value: string
) {
  if (isInitialLoad.value) return;  // Skip during initial data load

  const sectionConfig = WRITE_FIELD_MAPPING[section];
  if (!sectionConfig) {
    console.error(`Invalid section: ${section}`);
    return;
  }

  const eyeMapping = sectionConfig[eye];
  if (!eyeMapping) {
    console.error(`Invalid eye: ${eye}`);
    return;
  }

  const apiFieldName = eyeMapping[field as keyof typeof eyeMapping];
  if (!apiFieldName) {
    console.error(`Invalid field: ${field}`);
    return;
  }

  const key = `${sectionConfig.measurementType}`;

  // Add change to the pending list
  if (!pending[key]) {
    pending[key] = {};
  }
  pending[key][apiFieldName] = value;

  // Launch debounce. (Only the last occurrence of debounce is executed when multiple are sent at the same time)
  debouncedFlush();
}

async function flush() {
  const pendingContainsData = Object.keys(pending).length > 0;
  if (!pendingContainsData) {
    return;
  }

  // Add pending field changes to the snapshot (to be processed in the backend)
  const snapshot: PendingChanges = {};
  for (const measurementType of Object.keys(pending)) {
    snapshot[measurementType] = pending[measurementType];
    delete pending[measurementType];
  }

  try {
    await updateOphthalmicField(snapshot);
  } catch (e) {
    // Error => reassign changes to the pending list
    for (const [measurementType, fields] of Object.entries(snapshot)) {
      if (!pending[measurementType]) {
        pending[measurementType] = {};
      }
      Object.assign(pending[measurementType], fields);
    }
  }
}

// ============================================
// FIELD WATCHERS FOR AUTO-SAVE
// ============================================

function watchRefractionRef(
  refData: RefractionRef,
  section: SectionKey,
  eye: EyeKey,
  fields: string[] = ['sphere', 'cylinder', 'axis', 'add', 'va', 'nva']
) {
  fields.forEach(field => {
    watch(
      () => refData.value[field as keyof typeof refData.value],
      (val) => queueRefractionChange(section, eye, field, val),
        { flush: 'post' }
    );
  });
}

// Final Refraction watchers
watchRefractionRef(finalRefractionRight, 'finalRefraction', 'right');
watchRefractionRef(finalRefractionLeft, 'finalRefraction', 'left');

// Subjective watchers (no add, nva)
watchRefractionRef(subjectiveRight, 'subjective', 'right');
watchRefractionRef(subjectiveLeft, 'subjective', 'left');

// Objective watchers (no add, nva)
watchRefractionRef(objectiveRight, 'objective', 'right');
watchRefractionRef(objectiveLeft, 'objective', 'left');

// Glasses watchers (no va, nva)
watchRefractionRef(glassesRight, 'glasses', 'right');
watchRefractionRef(glassesLeft, 'glasses', 'left');

// Slit lamp watchers
watch(slitLampRightEye, (val) => queueRefractionChange('slitLamp', 'right', 'findings', val));
watch(slitLampLeftEye, (val) => queueRefractionChange('slitLamp', 'left', 'findings', val));

// IOP watchers
watch(iopRightEye, (val) => queueRefractionChange('iop', 'right', 'value', val));
watch(iopLeftEye, (val) => queueRefractionChange('iop', 'left', 'value', val));
watch(pachymetryRightEye, (val) => queueRefractionChange('pachymetry', 'right', 'value', val));
watch(pachymetryLeftEye, (val) => queueRefractionChange('pachymetry', 'left', 'value', val));

// Fundus note watchers
watch(fundusRightEye, (val) => queueRefractionChange('fundus', 'right', 'findings', val));
watch(fundusLeftEye, (val) => queueRefractionChange('fundus', 'left', 'findings', val));

// ============================================
// HISTORY & IMAGE STATE
// ============================================

// Store previous IDs to detect changes
const previousExpressionIds = ref<Record<string, string | undefined>>({});

// Selected history items for each section
const selectedPreviousItems = ref<Record<string, HistoryItem | null>>({
  fundusRight: null,
  fundusLeft: null,
  visualFieldRight: null,
  visualFieldLeft: null,
  octRight: null,
  octLeft: null,
  octBoth: null,
});

// Image URLs for all sections
const imageUrls = ref<Record<string, string | null>>({
  fundusRightCurrent: null,
  fundusRightPrevious: null,
  fundusLeftCurrent: null,
  fundusLeftPrevious: null,
  visualFieldRightCurrent: null,
  visualFieldRightPrevious: null,
  visualFieldLeftCurrent: null,
  visualFieldLeftPrevious: null,
  topographyRightCurrent: null,
  topographyRightPrevious: null,
  topographyLeftCurrent: null,
  topographyLeftPrevious: null,
  ultrasoundRightCurrent: null,
  ultrasoundRightPrevious: null,
  ultrasoundLeftCurrent: null,
  ultrasoundLeftPrevious: null,
  biometricsRightCurrent: null,
  biometricsRightPrevious: null,
  biometricsLeftCurrent: null,
  biometricsLeftPrevious: null,
  octRightCurrent: null,
  octRightPrevious: null,
  octLeftCurrent: null,
  octLeftPrevious: null,
  octBothCurrent: null,
  octBothPrevious: null,
});

// ============================================
// IMAGE VIEWER MODAL STATE
// ============================================
const imageViewerVisible = ref(false);
const selectedImage = ref<ImageData | null>(null);
const comparisonImage = ref<ImageData | null>(null);

// ============================================
// HISTORY DROPDOWN METHODS
// ============================================

function getHistory(section: string): HistoryItem[] {
  if (!dashbData.value) return [];
  
  const sectionMap: Record<string, () => HistoryItem[] | undefined> = {
    fundusRight: () => dashbData.value?.fundus?.rightEye?.file?.history,
    fundusLeft: () => dashbData.value?.fundus?.leftEye?.file?.history,
    visualFieldRight: () => dashbData.value?.visualField?.visualFieldRight?.history,
    visualFieldLeft: () => dashbData.value?.visualField?.visualFieldLeft?.history,
    octRight: () => dashbData.value?.oct?.octRight?.history,
    octLeft: () => dashbData.value?.oct?.octLeft?.history,
    octBoth: () => dashbData.value?.oct?.octBoth?.history,
  };
  
  const history = sectionMap[section]?.() || [];
  
  return [...history].sort((a, b) => 
    new Date(b.date).getTime() - new Date(a.date).getTime()
  );
}

function formatHistoryDate(dateString: string): string {
  if (!dateString) return '';
  const date = new Date(dateString);
  return date.toLocaleDateString(undefined, { 
    year: 'numeric', 
    month: 'short', 
    day: 'numeric' 
  });
}

async function selectHistoryItem(section: string, item: HistoryItem) {
  selectedPreviousItems.value[section] = item;
  const formattedKey = section.charAt(0).toLowerCase() + section.slice(1) + 'Previous';
  await loadImage(item.expression_CclId, formattedKey);
  dropd.value = "";
}

function getPreviousLabel(section: string): string {
  const selected = selectedPreviousItems.value[section];
  if (selected) {
    return formatHistoryDate(selected.date);
  }
  return t('patient.ophtalmo.previous');
}

function hasHistory(section: string): boolean {
  return getHistory(section).length > 0;
}

async function initializePreviousFromHistory(data: any) {
  const historyMappings = [
    { section: 'fundusRight', historyPath: () => data?.fundus?.rightEye?.file?.history, imageKey: 'fundusRightPrevious' },
    { section: 'fundusLeft', historyPath: () => data?.fundus?.leftEye?.file?.history, imageKey: 'fundusLeftPrevious' },
    { section: 'visualFieldRight', historyPath: () => data?.visualField?.visualFieldRight?.history, imageKey: 'visualFieldRightPrevious' },
    { section: 'visualFieldLeft', historyPath: () => data?.visualField?.visualFieldLeft?.history, imageKey: 'visualFieldLeftPrevious' },
    { section: 'topographyRight', historyPath: () => data?.topography?.topographyRight?.history, imageKey: 'topographyRightPrevious' },
    { section: 'topographyLeft', historyPath: () => data?.topography?.topographyLeft?.history, imageKey: 'topographyLeftPrevious' },
    { section: 'ultrasoundRight', historyPath: () => data?.ultrasound?.ultrasoundRight?.history, imageKey: 'ultrasoundRightPrevious' },
    { section: 'ultrasoundLeft', historyPath: () => data?.ultrasound?.ultrasoundLeft?.history, imageKey: 'ultrasoundLeftPrevious' },
    { section: 'biometricsRight', historyPath: () => data?.biometrics?.biometricsRight?.history, imageKey: 'biometricsRightPrevious' },
    { section: 'biometricsLeft', historyPath: () => data?.biometrics?.biometricsLeft?.history, imageKey: 'biometricsLeftPrevious' },
    { section: 'octRight', historyPath: () => data?.oct?.octRight?.history, imageKey: 'octRightPrevious' },
    { section: 'octLeft', historyPath: () => data?.oct?.octLeft?.history, imageKey: 'octLeftPrevious' },
    { section: 'octBoth', historyPath: () => data?.oct?.octBoth?.history, imageKey: 'octBothPrevious' },
  ];

  const loadPromises: Promise<void>[] = [];

  for (const { section, historyPath, imageKey } of historyMappings) {
    const history = historyPath();
    if (history && history.length > 0) {
      const sortedHistory = [...history].sort((a, b) => 
        new Date(b.date).getTime() - new Date(a.date).getTime()
      );
      const latestItem = sortedHistory[0];
      
      if (!selectedPreviousItems.value[section]) {
        selectedPreviousItems.value[section] = latestItem;
        loadPromises.push(loadImage(latestItem.expression_CclId, imageKey));
      }
    }
  }

  await Promise.all(loadPromises);
}

// ============================================
// IMAGE VIEWER METHODS
// ============================================

function getImageLabel(imageKey: string): string {
  const labels: Record<string, string> = {
    fundusRightCurrent: `${t('patient.ophtalmo.fundus')} ${t('patient.ophtalmo.od')} - ${t('patient.ophtalmo.current')}`,
    fundusRightPrevious: `${t('patient.ophtalmo.fundus')} ${t('patient.ophtalmo.od')} - ${t('patient.ophtalmo.previous')}`,
    fundusLeftCurrent: `${t('patient.ophtalmo.fundus')} ${t('patient.ophtalmo.os')} - ${t('patient.ophtalmo.current')}`,
    fundusLeftPrevious: `${t('patient.ophtalmo.fundus')} ${t('patient.ophtalmo.os')} - ${t('patient.ophtalmo.previous')}`,
    visualFieldRightCurrent: `${t('patient.ophtalmo.visualField')} ${t('patient.ophtalmo.od')} - ${t('patient.ophtalmo.current')}`,
    visualFieldRightPrevious: `${t('patient.ophtalmo.visualField')} ${t('patient.ophtalmo.od')} - ${t('patient.ophtalmo.previous')}`,
    visualFieldLeftCurrent: `${t('patient.ophtalmo.visualField')} ${t('patient.ophtalmo.os')} - ${t('patient.ophtalmo.current')}`,
    visualFieldLeftPrevious: `${t('patient.ophtalmo.visualField')} ${t('patient.ophtalmo.os')} - ${t('patient.ophtalmo.previous')}`,
    topographyRightCurrent: `${t('patient.ophtalmo.topography')} ${t('patient.ophtalmo.od')} - ${t('patient.ophtalmo.current')}`,
    topographyRightPrevious: `${t('patient.ophtalmo.topography')} ${t('patient.ophtalmo.od')} - ${t('patient.ophtalmo.previous')}`,
    topographyLeftCurrent: `${t('patient.ophtalmo.topography')} ${t('patient.ophtalmo.os')} - ${t('patient.ophtalmo.current')}`,
    topographyLeftPrevious: `${t('patient.ophtalmo.topography')} ${t('patient.ophtalmo.os')} - ${t('patient.ophtalmo.previous')}`,
    ultrasoundRightCurrent: `${t('patient.ophtalmo.ultrasound')} ${t('patient.ophtalmo.od')} - ${t('patient.ophtalmo.current')}`,
    ultrasoundRightPrevious: `${t('patient.ophtalmo.ultrasound')} ${t('patient.ophtalmo.od')} - ${t('patient.ophtalmo.previous')}`,
    ultrasoundLeftCurrent: `${t('patient.ophtalmo.ultrasound')} ${t('patient.ophtalmo.os')} - ${t('patient.ophtalmo.current')}`,
    ultrasoundLeftPrevious: `${t('patient.ophtalmo.ultrasound')} ${t('patient.ophtalmo.os')} - ${t('patient.ophtalmo.previous')}`,
    biometricsRightCurrent: `${t('patient.ophtalmo.biometrics')} ${t('patient.ophtalmo.od')} - ${t('patient.ophtalmo.current')}`,
    biometricsRightPrevious: `${t('patient.ophtalmo.biometrics')} ${t('patient.ophtalmo.od')} - ${t('patient.ophtalmo.previous')}`,
    biometricsLeftCurrent: `${t('patient.ophtalmo.biometrics')} ${t('patient.ophtalmo.os')} - ${t('patient.ophtalmo.current')}`,
    biometricsLeftPrevious: `${t('patient.ophtalmo.biometrics')} ${t('patient.ophtalmo.os')} - ${t('patient.ophtalmo.previous')}`,
    octRightCurrent: `${t('patient.ophtalmo.oct')} ${t('patient.ophtalmo.od')} - ${t('patient.ophtalmo.current')}`,
    octRightPrevious: `${t('patient.ophtalmo.oct')} ${t('patient.ophtalmo.od')} - ${t('patient.ophtalmo.previous')}`,
    octLeftCurrent: `${t('patient.ophtalmo.oct')} ${t('patient.ophtalmo.os')} - ${t('patient.ophtalmo.current')}`,
    octLeftPrevious: `${t('patient.ophtalmo.oct')} ${t('patient.ophtalmo.os')} - ${t('patient.ophtalmo.previous')}`,
    octBothCurrent: `${t('patient.ophtalmo.oct')} ${t('patient.ophtalmo.ou')} - ${t('patient.ophtalmo.current')}`,
    octBothPrevious: `${t('patient.ophtalmo.oct')} ${t('patient.ophtalmo.ou')} - ${t('patient.ophtalmo.previous')}`,
  };
  return labels[imageKey] || imageKey;
}

function openComparisonViewer(currentKey: string, previousKey: string) {
  const currentUrl = imageUrls.value[currentKey];
  const previousUrl = imageUrls.value[previousKey];
  
  if (!currentUrl && !previousUrl) return;
  
  if (currentUrl && previousUrl) {
    selectedImage.value = {
      url: previousUrl,
      alt: getImageLabel(previousKey),
      label: getImageLabel(previousKey)
    };
    comparisonImage.value = {
      url: currentUrl,
      alt: getImageLabel(currentKey),
      label: getImageLabel(currentKey)
    };
  } else {
    const existingUrl = currentUrl || previousUrl;
    const existingKey = currentUrl ? currentKey : previousKey;
    selectedImage.value = {
      url: existingUrl!,
      alt: getImageLabel(existingKey),
      label: getImageLabel(existingKey)
    };
    comparisonImage.value = null;
  }
  
  imageViewerVisible.value = true;
}

function closeImageViewer() {
  imageViewerVisible.value = false;
  selectedImage.value = null;
  comparisonImage.value = null;
}

// ============================================
// DATA LOADING METHODS
// ============================================

async function loadImage(expressionCclId: string | undefined, key: string) {
  if (imageUrls.value[key]) {
    URL.revokeObjectURL(imageUrls.value[key]!);
    imageUrls.value[key] = null;
  }
  if (!expressionCclId) return;
  try {
    const respBlob = await patientapi.getResultDocumentStream(expressionCclId);
    const myBlob = new Blob([respBlob], { type: respBlob.type });
    imageUrls.value[key] = URL.createObjectURL(myBlob);
  } catch (error) {
    console.error(`Failed to load image for ${key}:`, error);
  }
}

async function loadImageIfChanged(expressionCclId: string | undefined, key: string) {
  const previousId = previousExpressionIds.value[key];
  if (expressionCclId !== previousId) {
    previousExpressionIds.value[key] = expressionCclId;
    await loadImage(expressionCclId, key);
  }
}

const imageMapping = [
  { key: 'fundusRightCurrent', path: (d: any) => d?.fundus?.rightEye?.file?.expression_CclId },
  { key: 'fundusRightPrevious', path: (d: any) => d?.fundus?.fundusRightPrevious?.expression_CclId },
  { key: 'fundusLeftCurrent', path: (d: any) => d?.fundus?.leftEye?.file?.expression_CclId },
  { key: 'fundusLeftPrevious', path: (d: any) => d?.fundus?.fundusLeftPrevious?.expression_CclId },
  { key: 'visualFieldRightCurrent', path: (d: any) => d?.visualField?.visualFieldRight?.expression_CclId },
  { key: 'visualFieldRightPrevious', path: (d: any) => d?.visualField?.visualFieldRightPrevious?.expression_CclId },
  { key: 'visualFieldLeftCurrent', path: (d: any) => d?.visualField?.visualFieldLeft?.expression_CclId },
  { key: 'visualFieldLeftPrevious', path: (d: any) => d?.visualField?.visualFieldLeftPrevious?.expression_CclId },
  { key: 'topographyRightCurrent', path: (d: any) => d?.topography?.topographyRight?.expression_CclId },
  { key: 'topographyRightPrevious', path: (d: any) => d?.topography?.topographyRightPrevious?.expression_CclId },
  { key: 'topographyLeftCurrent', path: (d: any) => d?.topography?.topographyLeft?.expression_CclId },
  { key: 'topographyLeftPrevious', path: (d: any) => d?.topography?.topographyLeftPrevious?.expression_CclId },
  { key: 'ultrasoundRightCurrent', path: (d: any) => d?.ultrasound?.ultrasoundRight?.expression_CclId },
  { key: 'ultrasoundRightPrevious', path: (d: any) => d?.ultrasound?.ultrasoundRightPrevious?.expression_CclId },
  { key: 'ultrasoundLeftCurrent', path: (d: any) => d?.ultrasound?.ultrasoundLeft?.expression_CclId },
  { key: 'ultrasoundLeftPrevious', path: (d: any) => d?.ultrasound?.ultrasoundLeftPrevious?.expression_CclId },
  { key: 'biometricsRightCurrent', path: (d: any) => d?.biometrics?.biometricsRight?.expression_CclId },
  { key: 'biometricsRightPrevious', path: (d: any) => d?.biometrics?.biometricsRightPrevious?.expression_CclId },
  { key: 'biometricsLeftCurrent', path: (d: any) => d?.biometrics?.biometricsLeft?.expression_CclId },
  { key: 'biometricsLeftPrevious', path: (d: any) => d?.biometrics?.biometricsLeftPrevious?.expression_CclId },
  { key: 'octRightCurrent', path: (d: any) => d?.oct?.octRight?.expression_CclId },
  { key: 'octRightPrevious', path: (d: any) => d?.oct?.octRightPrevious?.expression_CclId },
  { key: 'octLeftCurrent', path: (d: any) => d?.oct?.octLeft?.expression_CclId },
  { key: 'octLeftPrevious', path: (d: any) => d?.oct?.octLeftPrevious?.expression_CclId },
  { key: 'octBothCurrent', path: (d: any) => d?.oct?.octBoth?.expression_CclId },
  { key: 'octBothPrevious', path: (d: any) => d?.oct?.octBothPrevious?.expression_CclId },  
];

// ============================================
// TEMPLATE & PRESCRIPTION METHODS
// ============================================

async function createTemplate(internalCode: string, titleText: string, mainContentFieldText: string) {
  uiStore.clearDashBoard();
  currentEntryStore.setMiddleTab('docTemplate')
  currentEntryStore.emptyCurrentDoc()
  const existingTemplateDoc = await getExistingTemplateDoc(internalCode)
  if (existingTemplateDoc) {
    currentEntryStore.setCurrentDoc(existingTemplateDoc)
    currentEntryStore.reloadCurrentEntry();
  } else {
    const newDoc = await patientapi.addOfficialTemplateToCclZero(internalCode, titleText, mainContentFieldText, "None", currentEntryStore.currentEntryId, null)
    currentEntryStore.setCurrentDoc(newDoc)
    currentEntryStore.reloadCurrentEntry();
  }
}

async function getExistingTemplateDoc(internalCode: string) {
  const patientDocuments = currentEntryStore.allPatientDocuments;
  const sameTemplate = patientDocuments.find(patientDoc => {
    return patientDoc.templateStatus === 'Template' && patientDoc.documentGroup.internalCode === internalCode
  })
  return sameTemplate
    ? await patientapi.getPatientDocument(sameTemplate.patientDocumentId, currentEntryStore.currentEntryId)
    : null
}

// ============================================
// DATA WATCHER
// ============================================

watch(
  () => dashbData.value,
  async (data) => {
    if (!data) return;
    
    await initializePreviousFromHistory(data);
    
    // Glasses (Lensmeter)
    glassesRight.value.sphere = data?.lensmeter?.rightEye?.sphere || "";
    glassesRight.value.cylinder = data?.lensmeter?.rightEye?.cylinder || "";
    glassesRight.value.axis = data?.lensmeter?.rightEye?.axis || "";
    glassesRight.value.add = data?.lensmeter?.rightEye?.add || "";
    glassesRight.value.va = data?.lensmeter?.rightEye?.visualAcuity || "";
    glassesRight.value.nva = data?.lensmeter?.rightEye?.nearVisualAcuity || "";
    
    glassesLeft.value.sphere = data?.lensmeter?.leftEye?.sphere || "";
    glassesLeft.value.cylinder = data?.lensmeter?.leftEye?.cylinder || "";
    glassesLeft.value.axis = data?.lensmeter?.leftEye?.axis || "";
    glassesLeft.value.add = data?.lensmeter?.leftEye?.add || "";
    glassesLeft.value.va = data?.lensmeter?.leftEye?.visualAcuity || "";
    glassesLeft.value.nva = data?.lensmeter?.leftEye?.nearVisualAcuity || "";
    
    // Objective (Tonometer)
    objectiveRight.value.sphere = data?.tonometer?.rightEye?.sphere || "";
    objectiveRight.value.cylinder = data?.tonometer?.rightEye?.cylinder || "";
    objectiveRight.value.axis = data?.tonometer?.rightEye?.axis || "";
    objectiveRight.value.add = data?.tonometer?.rightEye?.add || "";
    objectiveRight.value.va = data?.tonometer?.rightEye?.visualAcuity || "";
    objectiveRight.value.nva = data?.tonometer?.rightEye?.nearVisualAcuity || "";
    
    objectiveLeft.value.sphere = data?.tonometer?.leftEye?.sphere || "";
    objectiveLeft.value.cylinder = data?.tonometer?.leftEye?.cylinder || "";
    objectiveLeft.value.axis = data?.tonometer?.leftEye?.axis || "";
    objectiveLeft.value.add = data?.tonometer?.leftEye?.add || "";
    objectiveLeft.value.va = data?.tonometer?.leftEye?.visualAcuity || "";
    objectiveLeft.value.nva = data?.tonometer?.leftEye?.nearVisualAcuity || "";
    
    // Subjective
    subjectiveRight.value.sphere = data?.refraction?.rightEye?.sphereSubj || "";
    subjectiveRight.value.cylinder = data?.refraction?.rightEye?.cylinderSubj || "";
    subjectiveRight.value.axis = data?.refraction?.rightEye?.axisSubj || "";
    subjectiveRight.value.add = data?.refraction?.rightEye?.addSubj || "";
    subjectiveRight.value.va = data?.refraction?.rightEye?.visualAcuitySubj || "";
    subjectiveRight.value.nva = data?.refraction?.rightEye?.nearVisualAcuitySubj || "";
    
    subjectiveLeft.value.sphere = data?.refraction?.leftEye?.sphereSubj || "";
    subjectiveLeft.value.cylinder = data?.refraction?.leftEye?.cylinderSubj || "";
    subjectiveLeft.value.axis = data?.refraction?.leftEye?.axisSubj || "";
    subjectiveLeft.value.add = data?.refraction?.leftEye?.addSubj || "";
    subjectiveLeft.value.va = data?.refraction?.leftEye?.visualAcuitySubj || "";
    subjectiveLeft.value.nva = data?.refraction?.leftEye?.nearVisualAcuitySubj || "";
    
    // Final Refraction (with fallbacks)
    finalRefractionRight.value.sphere = data.refraction?.rightEye?.sphereFinal || data.refraction?.rightEye?.sphereSubj || "";
    finalRefractionRight.value.cylinder = data.refraction?.rightEye?.cylinderFinal || data.refraction?.rightEye?.cylinderSubj || "";
    finalRefractionRight.value.axis = data.refraction?.rightEye?.axisFinal || data.refraction?.rightEye?.axisSubj || "";
    finalRefractionRight.value.add = data.refraction?.rightEye?.addFinal || data.refraction?.rightEye?.addSubj || "";
    finalRefractionRight.value.va = data.refraction?.rightEye?.visualAcuityFinal || data.refraction?.rightEye?.visualAcuitySubj || "";
    finalRefractionRight.value.nva = data.refraction?.rightEye?.nearVisualAcuityFinal || data.refraction?.rightEye?.nearVisualAcuitySubj || "";
    
    finalRefractionLeft.value.sphere = data.refraction?.leftEye?.sphereFinal || data.refraction?.leftEye?.sphereSubj || "";
    finalRefractionLeft.value.cylinder = data.refraction?.leftEye?.cylinderFinal || data.refraction?.leftEye?.cylinderSubj || "";
    finalRefractionLeft.value.axis = data.refraction?.leftEye?.axisFinal || data.refraction?.leftEye?.axisSubj || "";
    finalRefractionLeft.value.add = data.refraction?.leftEye?.addFinal || data.refraction?.leftEye?.addSubj || "";
    finalRefractionLeft.value.va = data.refraction?.leftEye?.visualAcuityFinal || data.refraction?.leftEye?.visualAcuitySubj || "";
    finalRefractionLeft.value.nva = data.refraction?.leftEye?.nearVisualAcuityFinal || data.refraction?.leftEye?.nearVisualAcuitySubj || "";

    // Slit Lamp
    slitLampRightEye.value = data?.slitLamp?.rightEye?.findings || "";
    slitLampLeftEye.value = data?.slitLamp?.leftEye?.findings || "";

    // IOP
    iopRightEye.value = data?.tonometer?.rightEye?.iop || "";
    iopLeftEye.value = data?.tonometer?.leftEye?.iop || "";

    // Pachymeter
    pachymetryRightEye.value = data?.tonometer?.rightEye?.pachymetry || "";
    pachymetryLeftEye.value = data?.tonometer?.leftEye?.pachymetry || "";
    
    // Fundus notes
    fundusRightEye.value = data?.fundus?.rightEye?.findings || "";
    fundusLeftEye.value = data?.fundus?.leftEye?.findings || "";

      // Images
    await Promise.all(
      imageMapping.map(({ key, path }) => loadImageIfChanged(path(data), key))
    );
    // Mark initial load as complete after data is populated
    nextTick(() => {
      isInitialLoad.value = false;
    });
  },
  { immediate: true }
);

// ============================================
// FILE HANDLING METHODS
// ============================================

function revokeAllUrls() {
  Object.values(imageUrls.value).forEach(url => {
    if (url) URL.revokeObjectURL(url);
  });
}

const handleEyeClick = async (section: string, eye: string, file: File) => {
  const patientId = route.params.patientId as string;
  const measurementType = section.toUpperCase();
  const reference = (section + eye).replace(/_/g, "");
  const files = { [reference]: file };
  await patientapi.importOphthalmicMeasurement(patientId, measurementType, files);
  currentEntryStore.reloadCurrentEntry();
  getPatientDashboardOphtalmo();
};

const detectMeasurementType = (filename: string): string | null => {
  const patterns: [string, RegExp][] = [
    // Regex for production
    ['Lensmeter', /LM__20251024191223_014204.xml/],                         
    ['Tonometer', /tonoref-tonometer/i],
    ['Tonometer', /RKT_[ ]{14}_20251024191223.xml/i],
    // Regex for test
    ['Refraction', /rt6100-refraction/i],
    ['Lensmeter', /^LM_.*\.xml$/],
    ['Tonometer', /^RKT_.*\.xml$/],
    ['Refraction', /^RT_.*\.xml$/],
  ];
  for (const [type, pattern] of patterns) {
    if (pattern.test(filename)) {
      return type;
    }
  }
  return null;
};

async function sendAllToRefraction() {
  sendToRefraction("LENSMETER");
  sendToRefraction("TONOMETER");
}

async function sendToRefraction(inputDeviceType: string) {
  const patientId = route.params.patientId as string;
  try {
    const resp = await patientapi.generateMeasureInputFile(patientId, inputDeviceType);
    if (!resp) {
      toastError(toast, {
        summary: t('common.toast.error'),
        detail: t('error.NO_DATA')
      });
      return;
    }
    const headerFilename = gen.extractFilenameFromHeaders(resp.headers);
    const fileName = headerFilename?.fileName;
    const fileExtension = headerFilename?.fileExtension || "xml";
    gen.downloadBlob(await resp.blob(), fileName, fileExtension);
    toastSuccess(toast, {
      summary: t('common.toast.success'),
      detail: t('ophthalmology.export.success')
    });
  } catch (error) {
    toastError(toast, {
      summary: t('common.toast.error'),
      detail: t('error.DEFAULT')
    });
  }
}

const handleImportXmlClick = async (file: File) => {
  const patientId = route.params.patientId as string;
  const measurementType = detectMeasurementType(file.name);
  if (!measurementType) {
    console.error(`Could not determine measurement type from filename: ${file.name}`);
    return;
  }
  const files = { xmlFile: file };
  await patientapi.importOphthalmicMeasurement(patientId, measurementType.toUpperCase(), files);
  currentEntryStore.reloadCurrentEntry();
  getPatientDashboardOphtalmo();
};

const getPatientDashboardOphtalmo = async () => {
  const patientId = route.params.patientId as string;
  dashbData.value = await patientapi.getPatientDashboardOphtalmo(patientId) || null;
};

onMounted(() => {
  getPatientDashboardOphtalmo();
});

onBeforeUnmount(() => {
  revokeAllUrls();
  currentEntryStore.reloadCurrentEntry();
});

return (_ctx: any,_cache: any) => {
  const _component_text_item = _resolveComponent("text-item")!
  const _component_svg_item = _resolveComponent("svg-item")!
  const _component_buttonGroup = _resolveComponent("buttonGroup")!
  const _component_file_upload = _resolveComponent("file-upload")!
  const _component_inputLineNew2 = _resolveComponent("inputLineNew2")!
  const _component_list_group = _resolveComponent("list-group")!
  const _component_dbGroup = _resolveComponent("dbGroup")!
  const _component_dropdownBox = _resolveComponent("dropdownBox")!
  const _component_inputAreaAuto2 = _resolveComponent("inputAreaAuto2")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      _cache[130] || (_cache[130] = _createElementVNode("div", null, null, -1)),
      _createVNode(_component_text_item, {
        txt: _unref(t)('patient.ophtalmo.od'),
        class: "align-c",
        styles: "font-xl"
      }, null, 8, ["txt"]),
      _cache[131] || (_cache[131] = _createElementVNode("div", null, null, -1)),
      _createVNode(_component_text_item, {
        txt: _unref(t)('patient.ophtalmo.os'),
        class: "align-c",
        styles: "font-xl"
      }, null, 8, ["txt"])
    ]),
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _cache[138] || (_cache[138] = _createElementVNode("div", { class: "vertical-spacer" }, null, -1)),
        _createElementVNode("div", _hoisted_4, _toDisplayString(_unref(t)('patient.ophtalmo.refraction')), 1),
        _createElementVNode("div", _hoisted_5, [
          _createVNode(_component_text_item, {
            txt: _unref(t)('patient.ophtalmo.sph'),
            class: "cell header"
          }, null, 8, ["txt"]),
          _createVNode(_component_text_item, {
            txt: _unref(t)('patient.ophtalmo.cyl'),
            class: "cell header"
          }, null, 8, ["txt"]),
          _createVNode(_component_text_item, {
            txt: _unref(t)('patient.ophtalmo.axs'),
            class: "cell header"
          }, null, 8, ["txt"]),
          _createVNode(_component_text_item, {
            txt: _unref(t)('patient.ophtalmo.add'),
            class: "cell header"
          }, null, 8, ["txt"]),
          _createVNode(_component_text_item, {
            txt: _unref(t)('patient.ophtalmo.va'),
            class: "cell header"
          }, null, 8, ["txt"]),
          _createVNode(_component_text_item, {
            txt: _unref(t)('patient.ophtalmo.nva'),
            class: "cell header"
          }, null, 8, ["txt"])
        ]),
        _cache[139] || (_cache[139] = _createElementVNode("div", null, null, -1)),
        _createElementVNode("div", _hoisted_6, [
          _createVNode(_component_text_item, {
            txt: _unref(t)('patient.ophtalmo.sph'),
            class: "cell header"
          }, null, 8, ["txt"]),
          _createVNode(_component_text_item, {
            txt: _unref(t)('patient.ophtalmo.cyl'),
            class: "cell header"
          }, null, 8, ["txt"]),
          _createVNode(_component_text_item, {
            txt: _unref(t)('patient.ophtalmo.axs'),
            class: "cell header"
          }, null, 8, ["txt"]),
          _createVNode(_component_text_item, {
            txt: _unref(t)('patient.ophtalmo.add'),
            class: "cell header"
          }, null, 8, ["txt"]),
          _createVNode(_component_text_item, {
            txt: _unref(t)('patient.ophtalmo.va'),
            class: "cell header"
          }, null, 8, ["txt"]),
          _createVNode(_component_text_item, {
            txt: _unref(t)('patient.ophtalmo.nva'),
            class: "cell header"
          }, null, 8, ["txt"])
        ]),
        _createElementVNode("div", _hoisted_7, [
          _createVNode(_component_file_upload, {
            id: 'lensmeter-upload',
            onFilesChanged: _cache[0] || (_cache[0] = (file) => handleImportXmlClick(file[0]))
          }, {
            default: _withCtx(() => [
              _createVNode(_component_buttonGroup, {
                styles: "pad-m",
                class: "row-label-btn"
              }, {
                default: _withCtx(() => [
                  _createElementVNode("span", null, _toDisplayString(_unref(t)('patient.ophtalmo.eyeGlasses')), 1),
                  _createElementVNode("div", _hoisted_8, [
                    _createVNode(_component_svg_item, {
                      icon: "plus",
                      styles: "size-s main-m "
                    })
                  ])
                ]),
                _: 1
              })
            ]),
            _: 1
          })
        ]),
        _createElementVNode("div", _hoisted_9, [
          _createElementVNode("div", _hoisted_10, [
            _createVNode(_component_inputLineNew2, {
              modelValue: _unref(glassesRight).sphere,
              "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_unref(glassesRight).sphere) = $event))
            }, null, 8, ["modelValue"])
          ]),
          _createElementVNode("div", _hoisted_11, [
            _createVNode(_component_inputLineNew2, {
              modelValue: _unref(glassesRight).cylinder,
              "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_unref(glassesRight).cylinder) = $event))
            }, null, 8, ["modelValue"])
          ]),
          _createElementVNode("div", _hoisted_12, [
            _createVNode(_component_inputLineNew2, {
              modelValue: _unref(glassesRight).axis,
              "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_unref(glassesRight).axis) = $event))
            }, null, 8, ["modelValue"])
          ]),
          _createElementVNode("div", _hoisted_13, [
            _createVNode(_component_inputLineNew2, {
              modelValue: _unref(glassesRight).add,
              "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_unref(glassesRight).add) = $event))
            }, null, 8, ["modelValue"])
          ]),
          _createElementVNode("div", _hoisted_14, [
            _createVNode(_component_inputLineNew2, {
              modelValue: _unref(glassesRight).va,
              "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((_unref(glassesRight).va) = $event))
            }, null, 8, ["modelValue"])
          ]),
          _createElementVNode("div", _hoisted_15, [
            _createVNode(_component_inputLineNew2, {
              modelValue: _unref(glassesRight).nva,
              "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((_unref(glassesRight).nva) = $event))
            }, null, 8, ["modelValue"])
          ])
        ]),
        _cache[140] || (_cache[140] = _createElementVNode("div", null, null, -1)),
        _createElementVNode("div", _hoisted_16, [
          _createElementVNode("div", _hoisted_17, [
            _createVNode(_component_inputLineNew2, {
              modelValue: _unref(glassesLeft).sphere,
              "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => ((_unref(glassesLeft).sphere) = $event))
            }, null, 8, ["modelValue"])
          ]),
          _createElementVNode("div", _hoisted_18, [
            _createVNode(_component_inputLineNew2, {
              modelValue: _unref(glassesLeft).cylinder,
              "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => ((_unref(glassesLeft).cylinder) = $event))
            }, null, 8, ["modelValue"])
          ]),
          _createElementVNode("div", _hoisted_19, [
            _createVNode(_component_inputLineNew2, {
              modelValue: _unref(glassesLeft).axis,
              "onUpdate:modelValue": _cache[9] || (_cache[9] = ($event: any) => ((_unref(glassesLeft).axis) = $event))
            }, null, 8, ["modelValue"])
          ]),
          _createElementVNode("div", _hoisted_20, [
            _createVNode(_component_inputLineNew2, {
              modelValue: _unref(glassesLeft).add,
              "onUpdate:modelValue": _cache[10] || (_cache[10] = ($event: any) => ((_unref(glassesLeft).add) = $event))
            }, null, 8, ["modelValue"])
          ]),
          _createElementVNode("div", _hoisted_21, [
            _createVNode(_component_inputLineNew2, {
              modelValue: _unref(glassesLeft).va,
              "onUpdate:modelValue": _cache[11] || (_cache[11] = ($event: any) => ((_unref(glassesLeft).va) = $event))
            }, null, 8, ["modelValue"])
          ]),
          _createElementVNode("div", _hoisted_22, [
            _createVNode(_component_inputLineNew2, {
              modelValue: _unref(glassesLeft).nva,
              "onUpdate:modelValue": _cache[12] || (_cache[12] = ($event: any) => ((_unref(glassesLeft).nva) = $event))
            }, null, 8, ["modelValue"])
          ])
        ]),
        _createElementVNode("div", _hoisted_23, [
          _createVNode(_component_file_upload, {
            id: 'tonoref-objective-upload',
            onFilesChanged: _cache[13] || (_cache[13] = (file) => handleImportXmlClick(file[0]))
          }, {
            default: _withCtx(() => [
              _createVNode(_component_buttonGroup, {
                styles: "pad-m",
                class: "row-label-btn"
              }, {
                default: _withCtx(() => [
                  _createElementVNode("span", null, _toDisplayString(_unref(t)('patient.ophtalmo.objective')), 1),
                  _createElementVNode("div", _hoisted_24, [
                    _createVNode(_component_svg_item, {
                      icon: "plus",
                      styles: "size-s main-m"
                    })
                  ])
                ]),
                _: 1
              })
            ]),
            _: 1
          })
        ]),
        _createElementVNode("div", _hoisted_25, [
          _createElementVNode("div", _hoisted_26, [
            _createVNode(_component_inputLineNew2, {
              modelValue: _unref(objectiveRight).sphere,
              "onUpdate:modelValue": _cache[14] || (_cache[14] = ($event: any) => ((_unref(objectiveRight).sphere) = $event))
            }, null, 8, ["modelValue"])
          ]),
          _createElementVNode("div", _hoisted_27, [
            _createVNode(_component_inputLineNew2, {
              modelValue: _unref(objectiveRight).cylinder,
              "onUpdate:modelValue": _cache[15] || (_cache[15] = ($event: any) => ((_unref(objectiveRight).cylinder) = $event))
            }, null, 8, ["modelValue"])
          ]),
          _createElementVNode("div", _hoisted_28, [
            _createVNode(_component_inputLineNew2, {
              modelValue: _unref(objectiveRight).axis,
              "onUpdate:modelValue": _cache[16] || (_cache[16] = ($event: any) => ((_unref(objectiveRight).axis) = $event))
            }, null, 8, ["modelValue"])
          ]),
          _createElementVNode("div", _hoisted_29, [
            _createVNode(_component_inputLineNew2, {
              modelValue: _unref(objectiveRight).add,
              "onUpdate:modelValue": _cache[17] || (_cache[17] = ($event: any) => ((_unref(objectiveRight).add) = $event))
            }, null, 8, ["modelValue"])
          ]),
          _createElementVNode("div", _hoisted_30, [
            _createVNode(_component_inputLineNew2, {
              modelValue: _unref(objectiveRight).va,
              "onUpdate:modelValue": _cache[18] || (_cache[18] = ($event: any) => ((_unref(objectiveRight).va) = $event))
            }, null, 8, ["modelValue"])
          ]),
          _createElementVNode("div", _hoisted_31, [
            _createVNode(_component_inputLineNew2, {
              modelValue: _unref(objectiveRight).nva,
              "onUpdate:modelValue": _cache[19] || (_cache[19] = ($event: any) => ((_unref(objectiveRight).nva) = $event))
            }, null, 8, ["modelValue"])
          ])
        ]),
        _cache[141] || (_cache[141] = _createElementVNode("div", null, null, -1)),
        _createElementVNode("div", _hoisted_32, [
          _createElementVNode("div", _hoisted_33, [
            _createVNode(_component_inputLineNew2, {
              modelValue: _unref(objectiveLeft).sphere,
              "onUpdate:modelValue": _cache[20] || (_cache[20] = ($event: any) => ((_unref(objectiveLeft).sphere) = $event))
            }, null, 8, ["modelValue"])
          ]),
          _createElementVNode("div", _hoisted_34, [
            _createVNode(_component_inputLineNew2, {
              modelValue: _unref(objectiveLeft).cylinder,
              "onUpdate:modelValue": _cache[21] || (_cache[21] = ($event: any) => ((_unref(objectiveLeft).cylinder) = $event))
            }, null, 8, ["modelValue"])
          ]),
          _createElementVNode("div", _hoisted_35, [
            _createVNode(_component_inputLineNew2, {
              modelValue: _unref(objectiveLeft).axis,
              "onUpdate:modelValue": _cache[22] || (_cache[22] = ($event: any) => ((_unref(objectiveLeft).axis) = $event))
            }, null, 8, ["modelValue"])
          ]),
          _createElementVNode("div", _hoisted_36, [
            _createVNode(_component_inputLineNew2, {
              modelValue: _unref(objectiveLeft).add,
              "onUpdate:modelValue": _cache[23] || (_cache[23] = ($event: any) => ((_unref(objectiveLeft).add) = $event))
            }, null, 8, ["modelValue"])
          ]),
          _createElementVNode("div", _hoisted_37, [
            _createVNode(_component_inputLineNew2, {
              modelValue: _unref(objectiveLeft).va,
              "onUpdate:modelValue": _cache[24] || (_cache[24] = ($event: any) => ((_unref(objectiveLeft).va) = $event))
            }, null, 8, ["modelValue"])
          ]),
          _createElementVNode("div", _hoisted_38, [
            _createVNode(_component_inputLineNew2, {
              modelValue: _unref(objectiveLeft).nva,
              "onUpdate:modelValue": _cache[25] || (_cache[25] = ($event: any) => ((_unref(objectiveLeft).nva) = $event))
            }, null, 8, ["modelValue"])
          ])
        ]),
        _createElementVNode("div", _hoisted_39, [
          _createVNode(_component_buttonGroup, {
            class: "mleft-auto",
            onClick: _cache[26] || (_cache[26] = ($event: any) => (sendAllToRefraction()))
          }, {
            default: _withCtx(() => [
              _createElementVNode("div", _hoisted_40, [
                _createVNode(_component_svg_item, {
                  icon: "upload",
                  styles: "size-s",
                  class: "img-primary",
                  style: {"margin-top":"-0.2rem"}
                })
              ])
            ]),
            _: 1
          }),
          _createVNode(_component_file_upload, {
            id: 'phoropter-subjective-upload',
            onFilesChanged: _cache[27] || (_cache[27] = (file) => handleImportXmlClick(file[0]))
          }, {
            default: _withCtx(() => [
              _createVNode(_component_buttonGroup, {
                styles: "pad-m",
                class: "row-label-btn"
              }, {
                default: _withCtx(() => [
                  _createElementVNode("span", null, _toDisplayString(_unref(t)('patient.ophtalmo.subjective')), 1),
                  _createElementVNode("div", _hoisted_41, [
                    _createVNode(_component_svg_item, {
                      icon: "plus",
                      styles: "size-s main-m"
                    })
                  ])
                ]),
                _: 1
              })
            ]),
            _: 1
          })
        ]),
        _createElementVNode("div", _hoisted_42, [
          _createElementVNode("div", _hoisted_43, [
            _createVNode(_component_inputLineNew2, {
              modelValue: _unref(subjectiveRight).sphere,
              "onUpdate:modelValue": _cache[28] || (_cache[28] = ($event: any) => ((_unref(subjectiveRight).sphere) = $event))
            }, null, 8, ["modelValue"])
          ]),
          _createElementVNode("div", _hoisted_44, [
            _createVNode(_component_inputLineNew2, {
              modelValue: _unref(subjectiveRight).cylinder,
              "onUpdate:modelValue": _cache[29] || (_cache[29] = ($event: any) => ((_unref(subjectiveRight).cylinder) = $event))
            }, null, 8, ["modelValue"])
          ]),
          _createElementVNode("div", _hoisted_45, [
            _createVNode(_component_inputLineNew2, {
              modelValue: _unref(subjectiveRight).axis,
              "onUpdate:modelValue": _cache[30] || (_cache[30] = ($event: any) => ((_unref(subjectiveRight).axis) = $event))
            }, null, 8, ["modelValue"])
          ]),
          _createElementVNode("div", _hoisted_46, [
            _createVNode(_component_inputLineNew2, {
              modelValue: _unref(subjectiveRight).add,
              "onUpdate:modelValue": _cache[31] || (_cache[31] = ($event: any) => ((_unref(subjectiveRight).add) = $event))
            }, null, 8, ["modelValue"])
          ]),
          _createElementVNode("div", _hoisted_47, [
            _createVNode(_component_inputLineNew2, {
              modelValue: _unref(subjectiveRight).va,
              "onUpdate:modelValue": _cache[32] || (_cache[32] = ($event: any) => ((_unref(subjectiveRight).va) = $event))
            }, null, 8, ["modelValue"])
          ]),
          _createElementVNode("div", _hoisted_48, [
            _createVNode(_component_inputLineNew2, {
              modelValue: _unref(subjectiveRight).nva,
              "onUpdate:modelValue": _cache[33] || (_cache[33] = ($event: any) => ((_unref(subjectiveRight).nva) = $event))
            }, null, 8, ["modelValue"])
          ])
        ]),
        _cache[142] || (_cache[142] = _createElementVNode("div", null, null, -1)),
        _createElementVNode("div", _hoisted_49, [
          _createElementVNode("div", _hoisted_50, [
            _createVNode(_component_inputLineNew2, {
              modelValue: _unref(subjectiveLeft).sphere,
              "onUpdate:modelValue": _cache[34] || (_cache[34] = ($event: any) => ((_unref(subjectiveLeft).sphere) = $event))
            }, null, 8, ["modelValue"])
          ]),
          _createElementVNode("div", _hoisted_51, [
            _createVNode(_component_inputLineNew2, {
              modelValue: _unref(subjectiveLeft).cylinder,
              "onUpdate:modelValue": _cache[35] || (_cache[35] = ($event: any) => ((_unref(subjectiveLeft).cylinder) = $event))
            }, null, 8, ["modelValue"])
          ]),
          _createElementVNode("div", _hoisted_52, [
            _createVNode(_component_inputLineNew2, {
              modelValue: _unref(subjectiveLeft).axis,
              "onUpdate:modelValue": _cache[36] || (_cache[36] = ($event: any) => ((_unref(subjectiveLeft).axis) = $event))
            }, null, 8, ["modelValue"])
          ]),
          _createElementVNode("div", _hoisted_53, [
            _createVNode(_component_inputLineNew2, {
              modelValue: _unref(subjectiveLeft).add,
              "onUpdate:modelValue": _cache[37] || (_cache[37] = ($event: any) => ((_unref(subjectiveLeft).add) = $event))
            }, null, 8, ["modelValue"])
          ]),
          _createElementVNode("div", _hoisted_54, [
            _createVNode(_component_inputLineNew2, {
              modelValue: _unref(subjectiveLeft).va,
              "onUpdate:modelValue": _cache[38] || (_cache[38] = ($event: any) => ((_unref(subjectiveLeft).va) = $event))
            }, null, 8, ["modelValue"])
          ]),
          _createElementVNode("div", _hoisted_55, [
            _createVNode(_component_inputLineNew2, {
              modelValue: _unref(subjectiveLeft).nva,
              "onUpdate:modelValue": _cache[39] || (_cache[39] = ($event: any) => ((_unref(subjectiveLeft).nva) = $event))
            }, null, 8, ["modelValue"])
          ])
        ]),
        _createElementVNode("div", _hoisted_56, [
          _createElementVNode("span", null, _toDisplayString(_unref(t)('patient.ophtalmo.final')), 1)
        ]),
        _createElementVNode("div", _hoisted_57, [
          _createElementVNode("div", _hoisted_58, [
            _createVNode(_component_inputLineNew2, {
              modelValue: _unref(finalRefractionRight).sphere,
              "onUpdate:modelValue": _cache[40] || (_cache[40] = ($event: any) => ((_unref(finalRefractionRight).sphere) = $event))
            }, null, 8, ["modelValue"])
          ]),
          _createElementVNode("div", _hoisted_59, [
            _createVNode(_component_inputLineNew2, {
              modelValue: _unref(finalRefractionRight).cylinder,
              "onUpdate:modelValue": _cache[41] || (_cache[41] = ($event: any) => ((_unref(finalRefractionRight).cylinder) = $event))
            }, null, 8, ["modelValue"])
          ]),
          _createElementVNode("div", _hoisted_60, [
            _createVNode(_component_inputLineNew2, {
              modelValue: _unref(finalRefractionRight).axis,
              "onUpdate:modelValue": _cache[42] || (_cache[42] = ($event: any) => ((_unref(finalRefractionRight).axis) = $event))
            }, null, 8, ["modelValue"])
          ]),
          _createElementVNode("div", _hoisted_61, [
            _createVNode(_component_inputLineNew2, {
              modelValue: _unref(finalRefractionRight).add,
              "onUpdate:modelValue": _cache[43] || (_cache[43] = ($event: any) => ((_unref(finalRefractionRight).add) = $event))
            }, null, 8, ["modelValue"])
          ]),
          _createElementVNode("div", _hoisted_62, [
            _createVNode(_component_inputLineNew2, {
              modelValue: _unref(finalRefractionRight).va,
              "onUpdate:modelValue": _cache[44] || (_cache[44] = ($event: any) => ((_unref(finalRefractionRight).va) = $event))
            }, null, 8, ["modelValue"])
          ]),
          _createElementVNode("div", _hoisted_63, [
            _createVNode(_component_inputLineNew2, {
              modelValue: _unref(finalRefractionRight).nva,
              "onUpdate:modelValue": _cache[45] || (_cache[45] = ($event: any) => ((_unref(finalRefractionRight).nva) = $event))
            }, null, 8, ["modelValue"])
          ])
        ]),
        _cache[143] || (_cache[143] = _createElementVNode("div", null, null, -1)),
        _createElementVNode("div", _hoisted_64, [
          _createElementVNode("div", _hoisted_65, [
            _createVNode(_component_inputLineNew2, {
              modelValue: _unref(finalRefractionLeft).sphere,
              "onUpdate:modelValue": _cache[46] || (_cache[46] = ($event: any) => ((_unref(finalRefractionLeft).sphere) = $event))
            }, null, 8, ["modelValue"])
          ]),
          _createElementVNode("div", _hoisted_66, [
            _createVNode(_component_inputLineNew2, {
              modelValue: _unref(finalRefractionLeft).cylinder,
              "onUpdate:modelValue": _cache[47] || (_cache[47] = ($event: any) => ((_unref(finalRefractionLeft).cylinder) = $event))
            }, null, 8, ["modelValue"])
          ]),
          _createElementVNode("div", _hoisted_67, [
            _createVNode(_component_inputLineNew2, {
              modelValue: _unref(finalRefractionLeft).axis,
              "onUpdate:modelValue": _cache[48] || (_cache[48] = ($event: any) => ((_unref(finalRefractionLeft).axis) = $event))
            }, null, 8, ["modelValue"])
          ]),
          _createElementVNode("div", _hoisted_68, [
            _createVNode(_component_inputLineNew2, {
              modelValue: _unref(finalRefractionLeft).add,
              "onUpdate:modelValue": _cache[49] || (_cache[49] = ($event: any) => ((_unref(finalRefractionLeft).add) = $event))
            }, null, 8, ["modelValue"])
          ]),
          _createElementVNode("div", _hoisted_69, [
            _createVNode(_component_inputLineNew2, {
              modelValue: _unref(finalRefractionLeft).va,
              "onUpdate:modelValue": _cache[50] || (_cache[50] = ($event: any) => ((_unref(finalRefractionLeft).va) = $event))
            }, null, 8, ["modelValue"])
          ]),
          _createElementVNode("div", _hoisted_70, [
            _createVNode(_component_inputLineNew2, {
              modelValue: _unref(finalRefractionLeft).nva,
              "onUpdate:modelValue": _cache[51] || (_cache[51] = ($event: any) => ((_unref(finalRefractionLeft).nva) = $event))
            }, null, 8, ["modelValue"])
          ])
        ]),
        _cache[144] || (_cache[144] = _createElementVNode("div", { class: "row-label" }, null, -1)),
        _createElementVNode("div", _hoisted_71, [
          _createVNode(_component_dropdownBox, {
            modelValue: dropd.value,
            "onUpdate:modelValue": _cache[57] || (_cache[57] = ($event: any) => ((dropd).value = $event)),
            openOn: "eyeGlassesPrescription",
            class: "mleft-auto"
          }, {
            dropd: _withCtx(() => [
              _createElementVNode("div", _hoisted_72, [
                _createVNode(_component_dbGroup, null, {
                  default: _withCtx(() => [
                    _createVNode(_component_list_group, {
                      styles: "pad-s",
                      onClick: _cache[52] || (_cache[52] = ($event: any) => (createTemplate('EyeglassNearPrescription', _unref(t)('patient.ophtalmo.eyeGlasses'), 'NEAR')))
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_text_item, {
                          txt: _unref(t)('patient.ophtalmo.near')
                        }, null, 8, ["txt"])
                      ]),
                      _: 1
                    }),
                    _createVNode(_component_list_group, {
                      styles: "pad-s",
                      onClick: _cache[53] || (_cache[53] = ($event: any) => (createTemplate('EyeglassDistantPrescription', _unref(t)('patient.ophtalmo.eyeGlasses'), 'DISTANT')))
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_text_item, {
                          txt: _unref(t)('patient.ophtalmo.distant')
                        }, null, 8, ["txt"])
                      ]),
                      _: 1
                    }),
                    _cache[132] || (_cache[132] = _createElementVNode("div", { class: "line-h mtop-04 mbottom-04" }, null, -1)),
                    _createVNode(_component_list_group, {
                      styles: "pad-s",
                      onClick: _cache[54] || (_cache[54] = ($event: any) => (createTemplate('EyeglassPrescription', _unref(t)('patient.ophtalmo.eyeGlasses'), 'PROGR_INTERMED')))
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_text_item, {
                          txt: _unref(t)('patient.ophtalmo.intermediate')
                        }, null, 8, ["txt"])
                      ]),
                      _: 1
                    }),
                    _createVNode(_component_list_group, {
                      styles: "pad-s",
                      onClick: _cache[55] || (_cache[55] = ($event: any) => (createTemplate('EyeglassPrescription', _unref(t)('patient.ophtalmo.eyeGlasses'), 'BIFOC')))
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_text_item, {
                          txt: _unref(t)('patient.ophtalmo.bifocal')
                        }, null, 8, ["txt"])
                      ]),
                      _: 1
                    }),
                    _createVNode(_component_list_group, {
                      styles: "pad-s",
                      onClick: _cache[56] || (_cache[56] = ($event: any) => (createTemplate('EyeglassPrescription', _unref(t)('patient.ophtalmo.eyeGlasses'), 'PROGR')))
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_text_item, {
                          txt: _unref(t)('patient.ophtalmo.progressive')
                        }, null, 8, ["txt"])
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                })
              ])
            ]),
            default: _withCtx(() => [
              _createVNode(_component_buttonGroup, null, {
                default: _withCtx(() => [
                  _createVNode(_component_svg_item, {
                    icon: "fileText",
                    styles: "size-xs",
                    class: "img-primary"
                  }),
                  _createVNode(_component_text_item, {
                    txt: _unref(t)('patient.ophtalmo.eyeGlasses'),
                    class: "mleft-05 txt-primary"
                  }, null, 8, ["txt"])
                ]),
                _: 1
              })
            ]),
            _: 1
          }, 8, ["modelValue"]),
          _createVNode(_component_dropdownBox, {
            modelValue: dropd.value,
            "onUpdate:modelValue": _cache[64] || (_cache[64] = ($event: any) => ((dropd).value = $event)),
            openOn: "contactLensesPrescription"
          }, {
            dropd: _withCtx(() => [
              _createElementVNode("div", _hoisted_73, [
                _createVNode(_component_dbGroup, null, {
                  default: _withCtx(() => [
                    _createVNode(_component_list_group, {
                      styles: "pad-s",
                      onClick: _cache[58] || (_cache[58] = ($event: any) => (createTemplate('ContactlensDistantPrescription', _unref(t)('patient.ophtalmo.contactLenses'), '')))
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_text_item, {
                          txt: _unref(t)('patient.ophtalmo.distant')
                        }, null, 8, ["txt"])
                      ]),
                      _: 1
                    }),
                    _createVNode(_component_list_group, {
                      styles: "pad-s",
                      onClick: _cache[59] || (_cache[59] = ($event: any) => (createTemplate('ContactlensPrescription', _unref(t)('patient.ophtalmo.contactLenses'), '')))
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_text_item, {
                          txt: _unref(t)('patient.ophtalmo.progressive')
                        }, null, 8, ["txt"])
                      ]),
                      _: 1
                    }),
                    _cache[133] || (_cache[133] = _createElementVNode("div", { class: "line-h mtop-04 mbottom-04" }, null, -1)),
                    _createVNode(_component_list_group, {
                      styles: "pad-s",
                      onClick: _cache[60] || (_cache[60] = ($event: any) => (createTemplate('ContactlensPrescription', _unref(t)('patient.ophtalmo.contactLenses'), 'HIGH_AMETROPY')))
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_text_item, {
                          txt: _unref(t)('patient.ophtalmo.highAmetropy')
                        }, null, 8, ["txt"])
                      ]),
                      _: 1
                    }),
                    _cache[134] || (_cache[134] = _createElementVNode("div", { class: "line-h mtop-04 mbottom-04" }, null, -1)),
                    _createVNode(_component_list_group, {
                      styles: "pad-s",
                      onClick: _cache[61] || (_cache[61] = ($event: any) => (createTemplate('ContactlensPrescription', _unref(t)('patient.ophtalmo.contactLenses'), 'RIGID')))
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_text_item, {
                          txt: _unref(t)('patient.ophtalmo.rigid')
                        }, null, 8, ["txt"])
                      ]),
                      _: 1
                    }),
                    _createVNode(_component_list_group, {
                      styles: "pad-s",
                      onClick: _cache[62] || (_cache[62] = ($event: any) => (createTemplate('ContactlensPrescription', _unref(t)('patient.ophtalmo.contactLenses'), 'RIGID_KERATOCONUS')))
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_text_item, {
                          txt: _unref(t)('patient.ophtalmo.rigidKeratoconus')
                        }, null, 8, ["txt"])
                      ]),
                      _: 1
                    }),
                    _createVNode(_component_list_group, {
                      styles: "pad-s",
                      onClick: _cache[63] || (_cache[63] = ($event: any) => (createTemplate('ContactlensPrescription', _unref(t)('patient.ophtalmo.contactLenses'), 'RIGID_HIGH_AMETROPY')))
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_text_item, {
                          txt: _unref(t)('patient.ophtalmo.rigidHighAmetropy')
                        }, null, 8, ["txt"])
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                })
              ])
            ]),
            default: _withCtx(() => [
              _createVNode(_component_buttonGroup, null, {
                default: _withCtx(() => [
                  _createVNode(_component_svg_item, {
                    icon: "fileText",
                    styles: "size-xs",
                    class: "img-primary"
                  }),
                  _createVNode(_component_text_item, {
                    txt: _unref(t)('patient.ophtalmo.contactLenses'),
                    class: "mleft-05 txt-primary"
                  }, null, 8, ["txt"])
                ]),
                _: 1
              })
            ]),
            _: 1
          }, 8, ["modelValue"])
        ]),
        _cache[145] || (_cache[145] = _createElementVNode("div", null, null, -1)),
        _cache[146] || (_cache[146] = _createElementVNode("div", null, null, -1)),
        _cache[147] || (_cache[147] = _createElementVNode("div", { class: "vertical-spacer" }, null, -1)),
        _createElementVNode("div", _hoisted_74, [
          _createVNode(_component_file_upload, {
            id: 'tonoref-kerato-upload',
            onFilesChanged: _cache[65] || (_cache[65] = (file) => handleImportXmlClick(file[0]))
          }, {
            default: _withCtx(() => [
              _createVNode(_component_buttonGroup, {
                styles: "pad-m",
                class: "section-label-btn"
              }, {
                default: _withCtx(() => [
                  _createElementVNode("span", null, _toDisplayString(_unref(t)('patient.ophtalmo.keratometry')), 1),
                  _createElementVNode("div", _hoisted_75, [
                    _createVNode(_component_svg_item, {
                      icon: "plus",
                      styles: "size-s main-m"
                    })
                  ])
                ]),
                _: 1
              })
            ]),
            _: 1
          })
        ]),
        _createElementVNode("div", _hoisted_76, [
          _createVNode(_component_text_item, {
            txt: _unref(t)('patient.ophtalmo.diopter'),
            class: "cell header"
          }, null, 8, ["txt"]),
          _createVNode(_component_text_item, {
            txt: _unref(t)('patient.ophtalmo.axs'),
            class: "cell header"
          }, null, 8, ["txt"])
        ]),
        _cache[148] || (_cache[148] = _createElementVNode("div", null, null, -1)),
        _createElementVNode("div", _hoisted_77, [
          _createVNode(_component_text_item, {
            txt: _unref(t)('patient.ophtalmo.diopter'),
            class: "cell header"
          }, null, 8, ["txt"]),
          _createVNode(_component_text_item, {
            txt: _unref(t)('patient.ophtalmo.axs'),
            class: "cell header"
          }, null, 8, ["txt"])
        ]),
        _createElementVNode("div", _hoisted_78, [
          _createElementVNode("span", null, _toDisplayString(_unref(t)('patient.ophtalmo.k1')), 1)
        ]),
        _createElementVNode("div", _hoisted_79, [
          _createVNode(_component_text_item, {
            txt: dashbData.value?.tonometer?.rightEye?.k1Power3_3mm || '\u00A0',
            class: "cell"
          }, null, 8, ["txt"]),
          _createVNode(_component_text_item, {
            txt: dashbData.value?.tonometer?.rightEye?.k1Axis3_3mm || '\u00A0',
            class: "cell"
          }, null, 8, ["txt"])
        ]),
        _cache[149] || (_cache[149] = _createElementVNode("div", null, null, -1)),
        _createElementVNode("div", _hoisted_80, [
          _createVNode(_component_text_item, {
            txt: dashbData.value?.tonometer?.leftEye?.k1Power3_3mm || '\u00A0',
            class: "cell"
          }, null, 8, ["txt"]),
          _createVNode(_component_text_item, {
            txt: dashbData.value?.tonometer?.leftEye?.k1Axis3_3mm || '\u00A0',
            class: "cell"
          }, null, 8, ["txt"])
        ]),
        _createElementVNode("div", _hoisted_81, [
          _createElementVNode("span", null, _toDisplayString(_unref(t)('patient.ophtalmo.k2')), 1)
        ]),
        _createElementVNode("div", _hoisted_82, [
          _createVNode(_component_text_item, {
            txt: dashbData.value?.tonometer?.rightEye?.k2Power3_3mm || '\u00A0',
            class: "cell"
          }, null, 8, ["txt"]),
          _createVNode(_component_text_item, {
            txt: dashbData.value?.tonometer?.rightEye?.k2Axis3_3mm || '\u00A0',
            class: "cell"
          }, null, 8, ["txt"])
        ]),
        _cache[150] || (_cache[150] = _createElementVNode("div", null, null, -1)),
        _createElementVNode("div", _hoisted_83, [
          _createVNode(_component_text_item, {
            txt: dashbData.value?.tonometer?.leftEye?.k2Power3_3mm || '\u00A0',
            class: "cell"
          }, null, 8, ["txt"]),
          _createVNode(_component_text_item, {
            txt: dashbData.value?.tonometer?.leftEye?.k2Axis3_3mm || '\u00A0',
            class: "cell"
          }, null, 8, ["txt"])
        ]),
        _cache[151] || (_cache[151] = _createElementVNode("div", { class: "vertical-spacer" }, null, -1)),
        _createElementVNode("div", _hoisted_84, [
          _createVNode(_component_file_upload, {
            id: 'tonoref-pio-upload',
            onFilesChanged: _cache[66] || (_cache[66] = (file) => handleImportXmlClick(file[0]))
          }, {
            default: _withCtx(() => [
              _createVNode(_component_buttonGroup, {
                styles: "pad-m",
                class: "section-label-btn"
              }, {
                default: _withCtx(() => [
                  _createElementVNode("span", null, _toDisplayString(_unref(t)('patient.ophtalmo.iop')), 1),
                  _createElementVNode("div", _hoisted_85, [
                    _createVNode(_component_svg_item, {
                      icon: "plus",
                      styles: "size-s main-m"
                    })
                  ])
                ]),
                _: 1
              })
            ]),
            _: 1
          })
        ]),
        _createElementVNode("div", _hoisted_86, [
          _createElementVNode("div", _hoisted_87, [
            _createVNode(_component_inputAreaAuto2, {
              modelValue: iopRightEye.value,
              "onUpdate:modelValue": _cache[67] || (_cache[67] = ($event: any) => ((iopRightEye).value = $event)),
              placeholder: _unref(t)('patient.ophtalmo.iop') + ' ' + _unref(t)('patient.ophtalmo.od') + ' ...'
            }, null, 8, ["modelValue", "placeholder"])
          ])
        ]),
        _cache[152] || (_cache[152] = _createElementVNode("div", null, null, -1)),
        _createElementVNode("div", _hoisted_88, [
          _createElementVNode("div", _hoisted_89, [
            _createVNode(_component_inputAreaAuto2, {
              modelValue: iopLeftEye.value,
              "onUpdate:modelValue": _cache[68] || (_cache[68] = ($event: any) => ((iopLeftEye).value = $event)),
              placeholder: _unref(t)('patient.ophtalmo.iop') + ' ' + _unref(t)('patient.ophtalmo.os') + ' ...'
            }, null, 8, ["modelValue", "placeholder"])
          ])
        ]),
        _createElementVNode("div", _hoisted_90, _toDisplayString(_unref(t)('patient.ophtalmo.pachymetry')), 1),
        _createElementVNode("div", _hoisted_91, [
          _createElementVNode("div", _hoisted_92, [
            _createVNode(_component_inputAreaAuto2, {
              modelValue: pachymetryRightEye.value,
              "onUpdate:modelValue": _cache[69] || (_cache[69] = ($event: any) => ((pachymetryRightEye).value = $event)),
              placeholder: _unref(t)('patient.ophtalmo.pachymetry') + ' ' + _unref(t)('patient.ophtalmo.od') + ' ...'
            }, null, 8, ["modelValue", "placeholder"])
          ])
        ]),
        _cache[153] || (_cache[153] = _createElementVNode("div", null, null, -1)),
        _createElementVNode("div", _hoisted_93, [
          _createElementVNode("div", _hoisted_94, [
            _createVNode(_component_inputAreaAuto2, {
              modelValue: pachymetryLeftEye.value,
              "onUpdate:modelValue": _cache[70] || (_cache[70] = ($event: any) => ((pachymetryLeftEye).value = $event)),
              placeholder: _unref(t)('patient.ophtalmo.pachymetry') + ' ' + _unref(t)('patient.ophtalmo.os') + ' ...'
            }, null, 8, ["modelValue", "placeholder"])
          ])
        ]),
        _cache[154] || (_cache[154] = _createElementVNode("div", { class: "vertical-spacer" }, null, -1)),
        _createElementVNode("div", _hoisted_95, _toDisplayString(_unref(t)('patient.ophtalmo.slitLamp')), 1),
        _createElementVNode("div", _hoisted_96, [
          _createElementVNode("div", _hoisted_97, [
            _createVNode(_component_inputAreaAuto2, {
              modelValue: slitLampRightEye.value,
              "onUpdate:modelValue": _cache[71] || (_cache[71] = ($event: any) => ((slitLampRightEye).value = $event)),
              placeholder: _unref(t)('patient.ophtalmo.slitLamp') + ' ' + _unref(t)('patient.ophtalmo.od') + ' ...'
            }, null, 8, ["modelValue", "placeholder"])
          ])
        ]),
        _cache[155] || (_cache[155] = _createElementVNode("div", null, null, -1)),
        _createElementVNode("div", _hoisted_98, [
          _createElementVNode("div", _hoisted_99, [
            _createVNode(_component_inputAreaAuto2, {
              modelValue: slitLampLeftEye.value,
              "onUpdate:modelValue": _cache[72] || (_cache[72] = ($event: any) => ((slitLampLeftEye).value = $event)),
              placeholder: _unref(t)('patient.ophtalmo.slitLamp') + ' ' + _unref(t)('patient.ophtalmo.os') + ' ...'
            }, null, 8, ["modelValue", "placeholder"])
          ])
        ]),
        _cache[156] || (_cache[156] = _createElementVNode("div", { class: "vertical-spacer" }, null, -1)),
        _cache[157] || (_cache[157] = _createElementVNode("div", { class: "section-label" }, null, -1)),
        _createElementVNode("div", _hoisted_100, [
          _createElementVNode("div", _hoisted_101, [
            _createVNode(_component_dropdownBox, {
              modelValue: dropd.value,
              "onUpdate:modelValue": _cache[73] || (_cache[73] = ($event: any) => ((dropd).value = $event)),
              openOn: "fundusRightHistory"
            }, {
              dropd: _withCtx(() => [
                _createElementVNode("div", _hoisted_102, [
                  _createVNode(_component_dbGroup, null, {
                    default: _withCtx(() => [
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(getHistory('fundusRight'), (item) => {
                        return (_openBlock(), _createBlock(_component_list_group, {
                          key: item.expression_CclId,
                          styles: "pad-s",
                          onClick: ($event: any) => (selectHistoryItem('fundusRight', item))
                        }, {
                          default: _withCtx(() => [
                            _createVNode(_component_text_item, {
                              txt: formatHistoryDate(item.date)
                            }, null, 8, ["txt"])
                          ]),
                          _: 2
                        }, 1032, ["onClick"]))
                      }), 128)),
                      (!hasHistory('fundusRight'))
                        ? (_openBlock(), _createElementBlock("div", _hoisted_103, _toDisplayString(_unref(t)('patient.ophtalmo.noHistory')), 1))
                        : _createCommentVNode("", true)
                    ]),
                    _: 1
                  })
                ])
              ]),
              default: _withCtx(() => [
                _createVNode(_component_buttonGroup, { theme: "dropdown" }, {
                  default: _withCtx(() => [
                    _createVNode(_component_text_item, {
                      txt: getPreviousLabel('fundusRight'),
                      class: "txt-primary"
                    }, null, 8, ["txt"])
                  ]),
                  _: 1
                })
              ]),
              _: 1
            }, 8, ["modelValue"])
          ]),
          _createElementVNode("div", _hoisted_104, [
            _createVNode(_component_file_upload, {
              id: 'fundus-right-upload',
              onFilesChanged: _cache[74] || (_cache[74] = (file) => handleEyeClick('Fundus', 'Right', file[0]))
            }, {
              default: _withCtx(() => [
                _createVNode(_component_buttonGroup, null, {
                  default: _withCtx(() => [
                    _createVNode(_component_text_item, {
                      txt: _unref(t)('patient.ophtalmo.current'),
                      class: "txt-primary"
                    }, null, 8, ["txt"]),
                    _createElementVNode("div", _hoisted_105, [
                      _createVNode(_component_svg_item, {
                        icon: "plus",
                        styles: "size-s",
                        class: "img-primary"
                      })
                    ])
                  ]),
                  _: 1
                })
              ]),
              _: 1
            })
          ])
        ]),
        _cache[158] || (_cache[158] = _createElementVNode("div", null, null, -1)),
        _createElementVNode("div", _hoisted_106, [
          _createElementVNode("div", _hoisted_107, [
            _createVNode(_component_file_upload, {
              id: 'fundus-left-upload',
              onFilesChanged: _cache[75] || (_cache[75] = (file) => handleEyeClick('Fundus', 'Left', file[0]))
            }, {
              default: _withCtx(() => [
                _createVNode(_component_buttonGroup, null, {
                  default: _withCtx(() => [
                    _createVNode(_component_text_item, {
                      txt: _unref(t)('patient.ophtalmo.current'),
                      class: "txt-primary"
                    }, null, 8, ["txt"]),
                    _createElementVNode("div", _hoisted_108, [
                      _createVNode(_component_svg_item, {
                        icon: "plus",
                        styles: "size-s",
                        class: "img-primary"
                      })
                    ])
                  ]),
                  _: 1
                })
              ]),
              _: 1
            })
          ]),
          _createElementVNode("div", _hoisted_109, [
            _createVNode(_component_dropdownBox, {
              modelValue: dropd.value,
              "onUpdate:modelValue": _cache[76] || (_cache[76] = ($event: any) => ((dropd).value = $event)),
              openOn: "fundusLeftHistory"
            }, {
              dropd: _withCtx(() => [
                _createElementVNode("div", _hoisted_110, [
                  _createVNode(_component_dbGroup, null, {
                    default: _withCtx(() => [
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(getHistory('fundusLeft'), (item) => {
                        return (_openBlock(), _createBlock(_component_list_group, {
                          key: item.expression_CclId,
                          styles: "pad-s",
                          onClick: ($event: any) => (selectHistoryItem('fundusLeft', item))
                        }, {
                          default: _withCtx(() => [
                            _createVNode(_component_text_item, {
                              txt: formatHistoryDate(item.date)
                            }, null, 8, ["txt"])
                          ]),
                          _: 2
                        }, 1032, ["onClick"]))
                      }), 128)),
                      (!hasHistory('fundusLeft'))
                        ? (_openBlock(), _createElementBlock("div", _hoisted_111, _toDisplayString(_unref(t)('patient.ophtalmo.noHistory')), 1))
                        : _createCommentVNode("", true)
                    ]),
                    _: 1
                  })
                ])
              ]),
              default: _withCtx(() => [
                _createVNode(_component_buttonGroup, { theme: "dropdown" }, {
                  default: _withCtx(() => [
                    _createVNode(_component_text_item, {
                      txt: getPreviousLabel('fundusLeft'),
                      class: "txt-primary"
                    }, null, 8, ["txt"])
                  ]),
                  _: 1
                })
              ]),
              _: 1
            }, 8, ["modelValue"])
          ])
        ]),
        _createElementVNode("div", _hoisted_112, _toDisplayString(_unref(t)('patient.ophtalmo.fundus')), 1),
        _createElementVNode("div", _hoisted_113, [
          _createElementVNode("div", {
            class: _normalizeClass(["image-container", { 'clickable': imageUrls.value.fundusRightPrevious }]),
            onClick: _cache[77] || (_cache[77] = ($event: any) => (imageUrls.value.fundusRightPrevious && openComparisonViewer('fundusRightCurrent', 'fundusRightPrevious')))
          }, [
            (imageUrls.value.fundusRightPrevious)
              ? (_openBlock(), _createElementBlock("img", {
                  key: 0,
                  src: imageUrls.value.fundusRightPrevious,
                  alt: `${_unref(t)('patient.ophtalmo.fundus')} ${_unref(t)('patient.ophtalmo.od')} ${_unref(t)('patient.ophtalmo.previous')}`,
                  class: "eye-image"
                }, null, 8, _hoisted_114))
              : (_openBlock(), _createElementBlock("span", _hoisted_115, _toDisplayString(_unref(t)('patient.ophtalmo.previous')), 1))
          ], 2),
          _createElementVNode("div", {
            class: _normalizeClass(["image-container", { 'clickable': imageUrls.value.fundusRightCurrent }]),
            onClick: _cache[78] || (_cache[78] = ($event: any) => (imageUrls.value.fundusRightCurrent && openComparisonViewer('fundusRightCurrent', 'fundusRightPrevious')))
          }, [
            (imageUrls.value.fundusRightCurrent)
              ? (_openBlock(), _createElementBlock("img", {
                  key: 0,
                  src: imageUrls.value.fundusRightCurrent,
                  alt: `${_unref(t)('patient.ophtalmo.fundus')} ${_unref(t)('patient.ophtalmo.od')} ${_unref(t)('patient.ophtalmo.current')}`,
                  class: "eye-image"
                }, null, 8, _hoisted_116))
              : (_openBlock(), _createElementBlock("span", _hoisted_117, _toDisplayString(_unref(t)('patient.ophtalmo.current')), 1))
          ], 2)
        ]),
        _cache[159] || (_cache[159] = _createElementVNode("div", null, null, -1)),
        _createElementVNode("div", _hoisted_118, [
          _createElementVNode("div", {
            class: _normalizeClass(["image-container", { 'clickable': imageUrls.value.fundusLeftCurrent }]),
            onClick: _cache[79] || (_cache[79] = ($event: any) => (imageUrls.value.fundusLeftCurrent && openComparisonViewer('fundusLeftCurrent', 'fundusLeftPrevious')))
          }, [
            (imageUrls.value.fundusLeftCurrent)
              ? (_openBlock(), _createElementBlock("img", {
                  key: 0,
                  src: imageUrls.value.fundusLeftCurrent,
                  alt: `${_unref(t)('patient.ophtalmo.fundus')} ${_unref(t)('patient.ophtalmo.os')} ${_unref(t)('patient.ophtalmo.current')}`,
                  class: "eye-image"
                }, null, 8, _hoisted_119))
              : (_openBlock(), _createElementBlock("span", _hoisted_120, _toDisplayString(_unref(t)('patient.ophtalmo.current')), 1))
          ], 2),
          _createElementVNode("div", {
            class: _normalizeClass(["image-container", { 'clickable': imageUrls.value.fundusLeftPrevious }]),
            onClick: _cache[80] || (_cache[80] = ($event: any) => (imageUrls.value.fundusLeftPrevious && openComparisonViewer('fundusLeftCurrent', 'fundusLeftPrevious')))
          }, [
            (imageUrls.value.fundusLeftPrevious)
              ? (_openBlock(), _createElementBlock("img", {
                  key: 0,
                  src: imageUrls.value.fundusLeftPrevious,
                  alt: `${_unref(t)('patient.ophtalmo.fundus')} ${_unref(t)('patient.ophtalmo.os')} ${_unref(t)('patient.ophtalmo.previous')}`,
                  class: "eye-image"
                }, null, 8, _hoisted_121))
              : (_openBlock(), _createElementBlock("span", _hoisted_122, _toDisplayString(_unref(t)('patient.ophtalmo.previous')), 1))
          ], 2)
        ]),
        _cache[160] || (_cache[160] = _createElementVNode("div", { class: "row-label" }, null, -1)),
        _createElementVNode("div", _hoisted_123, [
          _createElementVNode("div", _hoisted_124, [
            _createVNode(_component_inputAreaAuto2, {
              modelValue: fundusRightEye.value,
              "onUpdate:modelValue": _cache[81] || (_cache[81] = ($event: any) => ((fundusRightEye).value = $event)),
              placeholder: _unref(t)('patient.ophtalmo.fundus') + ' ' + _unref(t)('patient.ophtalmo.od') + ' ...'
            }, null, 8, ["modelValue", "placeholder"])
          ])
        ]),
        _cache[161] || (_cache[161] = _createElementVNode("div", null, null, -1)),
        _createElementVNode("div", _hoisted_125, [
          _createElementVNode("div", _hoisted_126, [
            _createVNode(_component_inputAreaAuto2, {
              modelValue: fundusLeftEye.value,
              "onUpdate:modelValue": _cache[82] || (_cache[82] = ($event: any) => ((fundusLeftEye).value = $event)),
              placeholder: _unref(t)('patient.ophtalmo.fundus') + ' ' + _unref(t)('patient.ophtalmo.os') + ' ...'
            }, null, 8, ["modelValue", "placeholder"])
          ])
        ]),
        _cache[162] || (_cache[162] = _createElementVNode("div", { class: "vertical-spacer" }, null, -1)),
        (imageUrls.value.octBothCurrent)
          ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
              _createElementVNode("div", _hoisted_127, [
                _createElementVNode("div", _hoisted_128, [
                  _createElementVNode("div", _hoisted_129, [
                    _createVNode(_component_dropdownBox, {
                      modelValue: dropd.value,
                      "onUpdate:modelValue": _cache[83] || (_cache[83] = ($event: any) => ((dropd).value = $event)),
                      openOn: "octBothHistoryLeft"
                    }, {
                      dropd: _withCtx(() => [
                        _createElementVNode("div", _hoisted_130, [
                          _createVNode(_component_dbGroup, null, {
                            default: _withCtx(() => [
                              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(getHistory('octBoth'), (item) => {
                                return (_openBlock(), _createBlock(_component_list_group, {
                                  key: item.expression_CclId,
                                  styles: "pad-s",
                                  onClick: ($event: any) => (selectHistoryItem('octBoth', item))
                                }, {
                                  default: _withCtx(() => [
                                    _createVNode(_component_text_item, {
                                      txt: formatHistoryDate(item.date)
                                    }, null, 8, ["txt"])
                                  ]),
                                  _: 2
                                }, 1032, ["onClick"]))
                              }), 128)),
                              (!hasHistory('octBoth'))
                                ? (_openBlock(), _createElementBlock("div", _hoisted_131, _toDisplayString(_unref(t)('patient.ophtalmo.noHistory')), 1))
                                : _createCommentVNode("", true)
                            ]),
                            _: 1
                          })
                        ])
                      ]),
                      default: _withCtx(() => [
                        _createVNode(_component_buttonGroup, { theme: "dropdown" }, {
                          default: _withCtx(() => [
                            _createVNode(_component_text_item, {
                              txt: getPreviousLabel('octBoth'),
                              class: "txt-primary"
                            }, null, 8, ["txt"])
                          ]),
                          _: 1
                        })
                      ]),
                      _: 1
                    }, 8, ["modelValue"])
                  ]),
                  _createElementVNode("div", _hoisted_132, [
                    _createVNode(_component_file_upload, {
                      id: 'oct-both-upload',
                      onFilesChanged: _cache[84] || (_cache[84] = (file) => handleEyeClick('Oct', 'Both', file[0]))
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_buttonGroup, null, {
                          default: _withCtx(() => [
                            _createVNode(_component_text_item, {
                              txt: _unref(t)('patient.ophtalmo.current'),
                              class: "txt-primary"
                            }, null, 8, ["txt"]),
                            _createElementVNode("div", _hoisted_133, [
                              _createVNode(_component_svg_item, {
                                icon: "plus",
                                styles: "size-s",
                                class: "img-primary"
                              })
                            ])
                          ]),
                          _: 1
                        })
                      ]),
                      _: 1
                    })
                  ]),
                  _createElementVNode("div", _hoisted_134, [
                    _createVNode(_component_dropdownBox, {
                      modelValue: dropd.value,
                      "onUpdate:modelValue": _cache[85] || (_cache[85] = ($event: any) => ((dropd).value = $event)),
                      openOn: "octBothHistoryRight"
                    }, {
                      dropd: _withCtx(() => [
                        _createElementVNode("div", _hoisted_135, [
                          _createVNode(_component_dbGroup, null, {
                            default: _withCtx(() => [
                              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(getHistory('octBoth'), (item) => {
                                return (_openBlock(), _createBlock(_component_list_group, {
                                  key: item.expression_CclId,
                                  styles: "pad-s",
                                  onClick: ($event: any) => (selectHistoryItem('octBoth', item))
                                }, {
                                  default: _withCtx(() => [
                                    _createVNode(_component_text_item, {
                                      txt: formatHistoryDate(item.date)
                                    }, null, 8, ["txt"])
                                  ]),
                                  _: 2
                                }, 1032, ["onClick"]))
                              }), 128)),
                              (!hasHistory('octBoth'))
                                ? (_openBlock(), _createElementBlock("div", _hoisted_136, _toDisplayString(_unref(t)('patient.ophtalmo.noHistory')), 1))
                                : _createCommentVNode("", true)
                            ]),
                            _: 1
                          })
                        ])
                      ]),
                      default: _withCtx(() => [
                        _createVNode(_component_buttonGroup, { theme: "dropdown" }, {
                          default: _withCtx(() => [
                            _createVNode(_component_text_item, {
                              txt: getPreviousLabel('octBoth'),
                              class: "txt-primary"
                            }, null, 8, ["txt"])
                          ]),
                          _: 1
                        })
                      ]),
                      _: 1
                    }, 8, ["modelValue"])
                  ])
                ])
              ]),
              _createElementVNode("div", _hoisted_137, _toDisplayString(_unref(t)('patient.ophtalmo.oct')), 1),
              _createElementVNode("div", _hoisted_138, [
                _createElementVNode("div", _hoisted_139, [
                  _createElementVNode("div", {
                    class: _normalizeClass(["image-container", { 'clickable': imageUrls.value.octBothPrevious }]),
                    onClick: _cache[86] || (_cache[86] = ($event: any) => (imageUrls.value.octBothPrevious && openComparisonViewer('octBothCurrent', 'octBothPrevious')))
                  }, [
                    (imageUrls.value.octBothPrevious)
                      ? (_openBlock(), _createElementBlock("img", {
                          key: 0,
                          src: imageUrls.value.octBothPrevious,
                          alt: `${_unref(t)('patient.ophtalmo.oct')} ${_unref(t)('patient.ophtalmo.previous')}`,
                          class: "eye-image"
                        }, null, 8, _hoisted_140))
                      : (_openBlock(), _createElementBlock("span", _hoisted_141, _toDisplayString(_unref(t)('patient.ophtalmo.previous')), 1))
                  ], 2),
                  _createElementVNode("div", {
                    class: _normalizeClass(["image-container", { 'clickable': imageUrls.value.octBothCurrent }]),
                    onClick: _cache[87] || (_cache[87] = ($event: any) => (imageUrls.value.octBothCurrent && openComparisonViewer('octBothCurrent', 'octBothPrevious')))
                  }, [
                    (imageUrls.value.octBothCurrent)
                      ? (_openBlock(), _createElementBlock("img", {
                          key: 0,
                          src: imageUrls.value.octBothCurrent,
                          alt: `${_unref(t)('patient.ophtalmo.oct')} ${_unref(t)('patient.ophtalmo.current')}`,
                          class: "eye-image"
                        }, null, 8, _hoisted_142))
                      : (_openBlock(), _createElementBlock("span", _hoisted_143, _toDisplayString(_unref(t)('patient.ophtalmo.current')), 1))
                  ], 2),
                  _createElementVNode("div", {
                    class: _normalizeClass(["image-container", { 'clickable': imageUrls.value.octBothPrevious }]),
                    onClick: _cache[88] || (_cache[88] = ($event: any) => (imageUrls.value.octBothPrevious && openComparisonViewer('octBothCurrent', 'octBothPrevious')))
                  }, [
                    (imageUrls.value.octBothPrevious)
                      ? (_openBlock(), _createElementBlock("img", {
                          key: 0,
                          src: imageUrls.value.octBothPrevious,
                          alt: `${_unref(t)('patient.ophtalmo.oct')} ${_unref(t)('patient.ophtalmo.previous')}`,
                          class: "eye-image"
                        }, null, 8, _hoisted_144))
                      : (_openBlock(), _createElementBlock("span", _hoisted_145, _toDisplayString(_unref(t)('patient.ophtalmo.previous')), 1))
                  ], 2)
                ])
              ]),
              _cache[135] || (_cache[135] = _createElementVNode("div", null, null, -1))
            ], 64))
          : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
              _cache[136] || (_cache[136] = _createElementVNode("div", { class: "section-label" }, null, -1)),
              _createElementVNode("div", _hoisted_146, [
                _createElementVNode("div", _hoisted_147, [
                  _createVNode(_component_dropdownBox, {
                    modelValue: dropd.value,
                    "onUpdate:modelValue": _cache[89] || (_cache[89] = ($event: any) => ((dropd).value = $event)),
                    openOn: "octRightHistory"
                  }, {
                    dropd: _withCtx(() => [
                      _createElementVNode("div", _hoisted_148, [
                        _createVNode(_component_dbGroup, null, {
                          default: _withCtx(() => [
                            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(getHistory('octRight'), (item) => {
                              return (_openBlock(), _createBlock(_component_list_group, {
                                key: item.expression_CclId,
                                styles: "pad-s",
                                onClick: ($event: any) => (selectHistoryItem('octRight', item))
                              }, {
                                default: _withCtx(() => [
                                  _createVNode(_component_text_item, {
                                    txt: formatHistoryDate(item.date)
                                  }, null, 8, ["txt"])
                                ]),
                                _: 2
                              }, 1032, ["onClick"]))
                            }), 128)),
                            (!hasHistory('octRight'))
                              ? (_openBlock(), _createElementBlock("div", _hoisted_149, _toDisplayString(_unref(t)('patient.ophtalmo.noHistory')), 1))
                              : _createCommentVNode("", true)
                          ]),
                          _: 1
                        })
                      ])
                    ]),
                    default: _withCtx(() => [
                      _createVNode(_component_buttonGroup, { theme: "dropdown" }, {
                        default: _withCtx(() => [
                          _createVNode(_component_text_item, {
                            txt: getPreviousLabel('octRight'),
                            class: "txt-primary"
                          }, null, 8, ["txt"])
                        ]),
                        _: 1
                      })
                    ]),
                    _: 1
                  }, 8, ["modelValue"])
                ]),
                _createElementVNode("div", _hoisted_150, [
                  _createVNode(_component_file_upload, {
                    id: 'oct-right-upload',
                    onFilesChanged: _cache[90] || (_cache[90] = (file) => handleEyeClick('Oct', 'Right', file[0]))
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_buttonGroup, null, {
                        default: _withCtx(() => [
                          _createVNode(_component_text_item, {
                            txt: _unref(t)('patient.ophtalmo.current'),
                            class: "txt-primary"
                          }, null, 8, ["txt"]),
                          _createElementVNode("div", _hoisted_151, [
                            _createVNode(_component_svg_item, {
                              icon: "plus",
                              styles: "size-s",
                              class: "img-primary"
                            })
                          ])
                        ]),
                        _: 1
                      })
                    ]),
                    _: 1
                  })
                ])
              ]),
              _createElementVNode("div", _hoisted_152, [
                _createVNode(_component_file_upload, {
                  id: 'oct-both-upload',
                  onFilesChanged: _cache[91] || (_cache[91] = (file) => handleEyeClick('Oct', 'Both', file[0]))
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_buttonGroup, null, {
                      default: _withCtx(() => [
                        _createVNode(_component_text_item, {
                          txt: _unref(t)('patient.ophtalmo.ou'),
                          class: "txt-primary"
                        }, null, 8, ["txt"]),
                        _createElementVNode("div", _hoisted_153, [
                          _createVNode(_component_svg_item, {
                            icon: "plus",
                            styles: "size-s",
                            class: "img-primary"
                          })
                        ])
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                })
              ]),
              _createElementVNode("div", _hoisted_154, [
                _createElementVNode("div", _hoisted_155, [
                  _createVNode(_component_file_upload, {
                    id: 'oct-left-upload',
                    onFilesChanged: _cache[92] || (_cache[92] = (file) => handleEyeClick('Oct', 'Left', file[0]))
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_buttonGroup, null, {
                        default: _withCtx(() => [
                          _createVNode(_component_text_item, {
                            txt: _unref(t)('patient.ophtalmo.current'),
                            class: "txt-primary"
                          }, null, 8, ["txt"]),
                          _createElementVNode("div", _hoisted_156, [
                            _createVNode(_component_svg_item, {
                              icon: "plus",
                              styles: "size-s",
                              class: "img-primary"
                            })
                          ])
                        ]),
                        _: 1
                      })
                    ]),
                    _: 1
                  })
                ]),
                _createElementVNode("div", _hoisted_157, [
                  _createVNode(_component_dropdownBox, {
                    modelValue: dropd.value,
                    "onUpdate:modelValue": _cache[93] || (_cache[93] = ($event: any) => ((dropd).value = $event)),
                    openOn: "octLeftHistory"
                  }, {
                    dropd: _withCtx(() => [
                      _createElementVNode("div", _hoisted_158, [
                        _createVNode(_component_dbGroup, null, {
                          default: _withCtx(() => [
                            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(getHistory('octLeft'), (item) => {
                              return (_openBlock(), _createBlock(_component_list_group, {
                                key: item.expression_CclId,
                                styles: "pad-s",
                                onClick: ($event: any) => (selectHistoryItem('octLeft', item))
                              }, {
                                default: _withCtx(() => [
                                  _createVNode(_component_text_item, {
                                    txt: formatHistoryDate(item.date)
                                  }, null, 8, ["txt"])
                                ]),
                                _: 2
                              }, 1032, ["onClick"]))
                            }), 128)),
                            (!hasHistory('octLeft'))
                              ? (_openBlock(), _createElementBlock("div", _hoisted_159, _toDisplayString(_unref(t)('patient.ophtalmo.noHistory')), 1))
                              : _createCommentVNode("", true)
                          ]),
                          _: 1
                        })
                      ])
                    ]),
                    default: _withCtx(() => [
                      _createVNode(_component_buttonGroup, { theme: "dropdown" }, {
                        default: _withCtx(() => [
                          _createVNode(_component_text_item, {
                            txt: getPreviousLabel('octLeft'),
                            class: "txt-primary"
                          }, null, 8, ["txt"])
                        ]),
                        _: 1
                      })
                    ]),
                    _: 1
                  }, 8, ["modelValue"])
                ])
              ]),
              _createElementVNode("div", _hoisted_160, _toDisplayString(_unref(t)('patient.ophtalmo.oct')), 1),
              _createElementVNode("div", _hoisted_161, [
                _createElementVNode("div", {
                  class: _normalizeClass(["image-container", { 'clickable': imageUrls.value.octRightPrevious }]),
                  onClick: _cache[94] || (_cache[94] = ($event: any) => (imageUrls.value.octRightPrevious && openComparisonViewer('octRightCurrent', 'octRightPrevious')))
                }, [
                  (imageUrls.value.octRightPrevious)
                    ? (_openBlock(), _createElementBlock("img", {
                        key: 0,
                        src: imageUrls.value.octRightPrevious,
                        alt: `${_unref(t)('patient.ophtalmo.oct')} ${_unref(t)('patient.ophtalmo.od')} ${_unref(t)('patient.ophtalmo.previous')}`,
                        class: "eye-image"
                      }, null, 8, _hoisted_162))
                    : (_openBlock(), _createElementBlock("span", _hoisted_163, _toDisplayString(_unref(t)('patient.ophtalmo.previous')), 1))
                ], 2),
                _createElementVNode("div", {
                  class: _normalizeClass(["image-container", { 'clickable': imageUrls.value.octRightCurrent }]),
                  onClick: _cache[95] || (_cache[95] = ($event: any) => (imageUrls.value.octRightCurrent && openComparisonViewer('octRightCurrent', 'octRightPrevious')))
                }, [
                  (imageUrls.value.octRightCurrent)
                    ? (_openBlock(), _createElementBlock("img", {
                        key: 0,
                        src: imageUrls.value.octRightCurrent,
                        alt: `${_unref(t)('patient.ophtalmo.oct')} ${_unref(t)('patient.ophtalmo.od')} ${_unref(t)('patient.ophtalmo.current')}`,
                        class: "eye-image"
                      }, null, 8, _hoisted_164))
                    : (_openBlock(), _createElementBlock("span", _hoisted_165, _toDisplayString(_unref(t)('patient.ophtalmo.current')), 1))
                ], 2)
              ]),
              _cache[137] || (_cache[137] = _createElementVNode("div", null, null, -1)),
              _createElementVNode("div", _hoisted_166, [
                _createElementVNode("div", {
                  class: _normalizeClass(["image-container", { 'clickable': imageUrls.value.octLeftCurrent }]),
                  onClick: _cache[96] || (_cache[96] = ($event: any) => (imageUrls.value.octLeftCurrent && openComparisonViewer('octLeftCurrent', 'octLeftPrevious')))
                }, [
                  (imageUrls.value.octLeftCurrent)
                    ? (_openBlock(), _createElementBlock("img", {
                        key: 0,
                        src: imageUrls.value.octLeftCurrent,
                        alt: `${_unref(t)('patient.ophtalmo.oct')} ${_unref(t)('patient.ophtalmo.os')} ${_unref(t)('patient.ophtalmo.current')}`,
                        class: "eye-image"
                      }, null, 8, _hoisted_167))
                    : (_openBlock(), _createElementBlock("span", _hoisted_168, _toDisplayString(_unref(t)('patient.ophtalmo.current')), 1))
                ], 2),
                _createElementVNode("div", {
                  class: _normalizeClass(["image-container", { 'clickable': imageUrls.value.octLeftPrevious }]),
                  onClick: _cache[97] || (_cache[97] = ($event: any) => (imageUrls.value.octLeftPrevious && openComparisonViewer('octLeftCurrent', 'octLeftPrevious')))
                }, [
                  (imageUrls.value.octLeftPrevious)
                    ? (_openBlock(), _createElementBlock("img", {
                        key: 0,
                        src: imageUrls.value.octLeftPrevious,
                        alt: `${_unref(t)('patient.ophtalmo.oct')} ${_unref(t)('patient.ophtalmo.os')} ${_unref(t)('patient.ophtalmo.previous')}`,
                        class: "eye-image"
                      }, null, 8, _hoisted_169))
                    : (_openBlock(), _createElementBlock("span", _hoisted_170, _toDisplayString(_unref(t)('patient.ophtalmo.previous')), 1))
                ], 2)
              ])
            ], 64)),
        _cache[163] || (_cache[163] = _createElementVNode("div", { class: "vertical-spacer" }, null, -1)),
        _cache[164] || (_cache[164] = _createElementVNode("div", { class: "section-label" }, null, -1)),
        _createElementVNode("div", _hoisted_171, [
          _createElementVNode("div", _hoisted_172, [
            _createVNode(_component_dropdownBox, {
              modelValue: dropd.value,
              "onUpdate:modelValue": _cache[98] || (_cache[98] = ($event: any) => ((dropd).value = $event)),
              openOn: "visualFieldRightHistory"
            }, {
              dropd: _withCtx(() => [
                _createElementVNode("div", _hoisted_173, [
                  _createVNode(_component_dbGroup, null, {
                    default: _withCtx(() => [
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(getHistory('visualFieldRight'), (item) => {
                        return (_openBlock(), _createBlock(_component_list_group, {
                          key: item.expression_CclId,
                          styles: "pad-s",
                          onClick: ($event: any) => (selectHistoryItem('visualFieldRight', item))
                        }, {
                          default: _withCtx(() => [
                            _createVNode(_component_text_item, {
                              txt: formatHistoryDate(item.date)
                            }, null, 8, ["txt"])
                          ]),
                          _: 2
                        }, 1032, ["onClick"]))
                      }), 128)),
                      (!hasHistory('visualFieldRight'))
                        ? (_openBlock(), _createElementBlock("div", _hoisted_174, _toDisplayString(_unref(t)('patient.ophtalmo.noHistory')), 1))
                        : _createCommentVNode("", true)
                    ]),
                    _: 1
                  })
                ])
              ]),
              default: _withCtx(() => [
                _createVNode(_component_buttonGroup, { theme: "dropdown" }, {
                  default: _withCtx(() => [
                    _createVNode(_component_text_item, {
                      txt: getPreviousLabel('visualFieldRight'),
                      class: "txt-primary"
                    }, null, 8, ["txt"])
                  ]),
                  _: 1
                })
              ]),
              _: 1
            }, 8, ["modelValue"])
          ]),
          _createElementVNode("div", _hoisted_175, [
            _createVNode(_component_file_upload, {
              id: 'visualField-right-upload',
              onFilesChanged: _cache[99] || (_cache[99] = (file) => handleEyeClick('Visual_Field', 'Right', file[0]))
            }, {
              default: _withCtx(() => [
                _createVNode(_component_buttonGroup, null, {
                  default: _withCtx(() => [
                    _createVNode(_component_text_item, {
                      txt: _unref(t)('patient.ophtalmo.current'),
                      class: "txt-primary"
                    }, null, 8, ["txt"]),
                    _createElementVNode("div", _hoisted_176, [
                      _createVNode(_component_svg_item, {
                        icon: "plus",
                        styles: "size-s",
                        class: "img-primary"
                      })
                    ])
                  ]),
                  _: 1
                })
              ]),
              _: 1
            })
          ])
        ]),
        _cache[165] || (_cache[165] = _createElementVNode("div", null, null, -1)),
        _createElementVNode("div", _hoisted_177, [
          _createElementVNode("div", _hoisted_178, [
            _createVNode(_component_file_upload, {
              id: 'visualField-left-upload',
              onFilesChanged: _cache[100] || (_cache[100] = (file) => handleEyeClick('Visual_Field', 'Left', file[0]))
            }, {
              default: _withCtx(() => [
                _createVNode(_component_buttonGroup, null, {
                  default: _withCtx(() => [
                    _createVNode(_component_text_item, {
                      txt: _unref(t)('patient.ophtalmo.current'),
                      class: "txt-primary"
                    }, null, 8, ["txt"]),
                    _createElementVNode("div", _hoisted_179, [
                      _createVNode(_component_svg_item, {
                        icon: "plus",
                        styles: "size-s",
                        class: "img-primary"
                      })
                    ])
                  ]),
                  _: 1
                })
              ]),
              _: 1
            })
          ]),
          _createElementVNode("div", _hoisted_180, [
            _createVNode(_component_dropdownBox, {
              modelValue: dropd.value,
              "onUpdate:modelValue": _cache[101] || (_cache[101] = ($event: any) => ((dropd).value = $event)),
              openOn: "visualFieldLeftHistory"
            }, {
              dropd: _withCtx(() => [
                _createElementVNode("div", _hoisted_181, [
                  _createVNode(_component_dbGroup, null, {
                    default: _withCtx(() => [
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(getHistory('visualFieldLeft'), (item) => {
                        return (_openBlock(), _createBlock(_component_list_group, {
                          key: item.expression_CclId,
                          styles: "pad-s",
                          onClick: ($event: any) => (selectHistoryItem('visualFieldLeft', item))
                        }, {
                          default: _withCtx(() => [
                            _createVNode(_component_text_item, {
                              txt: formatHistoryDate(item.date)
                            }, null, 8, ["txt"])
                          ]),
                          _: 2
                        }, 1032, ["onClick"]))
                      }), 128)),
                      (!hasHistory('visualFieldLeft'))
                        ? (_openBlock(), _createElementBlock("div", _hoisted_182, _toDisplayString(_unref(t)('patient.ophtalmo.noHistory')), 1))
                        : _createCommentVNode("", true)
                    ]),
                    _: 1
                  })
                ])
              ]),
              default: _withCtx(() => [
                _createVNode(_component_buttonGroup, { theme: "dropdown" }, {
                  default: _withCtx(() => [
                    _createVNode(_component_text_item, {
                      txt: getPreviousLabel('visualFieldLeft'),
                      class: "txt-primary"
                    }, null, 8, ["txt"])
                  ]),
                  _: 1
                })
              ]),
              _: 1
            }, 8, ["modelValue"])
          ])
        ]),
        _createElementVNode("div", _hoisted_183, _toDisplayString(_unref(t)('patient.ophtalmo.visualField')), 1),
        _createElementVNode("div", _hoisted_184, [
          _createElementVNode("div", {
            class: _normalizeClass(["image-container", { 'clickable': imageUrls.value.visualFieldRightPrevious }]),
            onClick: _cache[102] || (_cache[102] = ($event: any) => (imageUrls.value.visualFieldRightPrevious && openComparisonViewer('visualFieldRightCurrent', 'visualFieldRightPrevious')))
          }, [
            (imageUrls.value.visualFieldRightPrevious)
              ? (_openBlock(), _createElementBlock("img", {
                  key: 0,
                  src: imageUrls.value.visualFieldRightPrevious,
                  alt: `${_unref(t)('patient.ophtalmo.visualField')} ${_unref(t)('patient.ophtalmo.od')} ${_unref(t)('patient.ophtalmo.previous')}`,
                  class: "eye-image"
                }, null, 8, _hoisted_185))
              : (_openBlock(), _createElementBlock("span", _hoisted_186, _toDisplayString(_unref(t)('patient.ophtalmo.previous')), 1))
          ], 2),
          _createElementVNode("div", {
            class: _normalizeClass(["image-container", { 'clickable': imageUrls.value.visualFieldRightCurrent }]),
            onClick: _cache[103] || (_cache[103] = ($event: any) => (imageUrls.value.visualFieldRightCurrent && openComparisonViewer('visualFieldRightCurrent', 'visualFieldRightPrevious')))
          }, [
            (imageUrls.value.visualFieldRightCurrent)
              ? (_openBlock(), _createElementBlock("img", {
                  key: 0,
                  src: imageUrls.value.visualFieldRightCurrent,
                  alt: `${_unref(t)('patient.ophtalmo.visualField')} ${_unref(t)('patient.ophtalmo.od')} ${_unref(t)('patient.ophtalmo.current')}`,
                  class: "eye-image"
                }, null, 8, _hoisted_187))
              : (_openBlock(), _createElementBlock("span", _hoisted_188, _toDisplayString(_unref(t)('patient.ophtalmo.current')), 1))
          ], 2)
        ]),
        _cache[166] || (_cache[166] = _createElementVNode("div", null, null, -1)),
        _createElementVNode("div", _hoisted_189, [
          _createElementVNode("div", {
            class: _normalizeClass(["image-container", { 'clickable': imageUrls.value.visualFieldLeftCurrent }]),
            onClick: _cache[104] || (_cache[104] = ($event: any) => (imageUrls.value.visualFieldLeftCurrent && openComparisonViewer('visualFieldLeftCurrent', 'visualFieldLeftPrevious')))
          }, [
            (imageUrls.value.visualFieldLeftCurrent)
              ? (_openBlock(), _createElementBlock("img", {
                  key: 0,
                  src: imageUrls.value.visualFieldLeftCurrent,
                  alt: `${_unref(t)('patient.ophtalmo.visualField')} ${_unref(t)('patient.ophtalmo.os')} ${_unref(t)('patient.ophtalmo.current')}`,
                  class: "eye-image"
                }, null, 8, _hoisted_190))
              : (_openBlock(), _createElementBlock("span", _hoisted_191, _toDisplayString(_unref(t)('patient.ophtalmo.current')), 1))
          ], 2),
          _createElementVNode("div", {
            class: _normalizeClass(["image-container", { 'clickable': imageUrls.value.visualFieldLeftPrevious }]),
            onClick: _cache[105] || (_cache[105] = ($event: any) => (imageUrls.value.visualFieldLeftPrevious && openComparisonViewer('visualFieldLeftCurrent', 'visualFieldLeftPrevious')))
          }, [
            (imageUrls.value.visualFieldLeftPrevious)
              ? (_openBlock(), _createElementBlock("img", {
                  key: 0,
                  src: imageUrls.value.visualFieldLeftPrevious,
                  alt: `${_unref(t)('patient.ophtalmo.visualField')} ${_unref(t)('patient.ophtalmo.os')} ${_unref(t)('patient.ophtalmo.previous')}`,
                  class: "eye-image"
                }, null, 8, _hoisted_192))
              : (_openBlock(), _createElementBlock("span", _hoisted_193, _toDisplayString(_unref(t)('patient.ophtalmo.previous')), 1))
          ], 2)
        ]),
        _cache[167] || (_cache[167] = _createElementVNode("div", { class: "vertical-spacer" }, null, -1)),
        _cache[168] || (_cache[168] = _createElementVNode("div", { class: "section-label" }, null, -1)),
        _createElementVNode("div", _hoisted_194, [
          _createElementVNode("div", _hoisted_195, [
            _createVNode(_component_dropdownBox, {
              modelValue: dropd.value,
              "onUpdate:modelValue": _cache[106] || (_cache[106] = ($event: any) => ((dropd).value = $event)),
              openOn: "topographyRightHistory"
            }, {
              dropd: _withCtx(() => [
                _createElementVNode("div", _hoisted_196, [
                  _createVNode(_component_dbGroup, null, {
                    default: _withCtx(() => [
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(getHistory('topographyRight'), (item) => {
                        return (_openBlock(), _createBlock(_component_list_group, {
                          key: item.expression_CclId,
                          styles: "pad-s",
                          onClick: ($event: any) => (selectHistoryItem('topographyRight', item))
                        }, {
                          default: _withCtx(() => [
                            _createVNode(_component_text_item, {
                              txt: formatHistoryDate(item.date)
                            }, null, 8, ["txt"])
                          ]),
                          _: 2
                        }, 1032, ["onClick"]))
                      }), 128)),
                      (!hasHistory('topographyRight'))
                        ? (_openBlock(), _createElementBlock("div", _hoisted_197, _toDisplayString(_unref(t)('patient.ophtalmo.noHistory')), 1))
                        : _createCommentVNode("", true)
                    ]),
                    _: 1
                  })
                ])
              ]),
              default: _withCtx(() => [
                _createVNode(_component_buttonGroup, { theme: "dropdown" }, {
                  default: _withCtx(() => [
                    _createVNode(_component_text_item, {
                      txt: getPreviousLabel('topographyRight'),
                      class: "txt-primary"
                    }, null, 8, ["txt"])
                  ]),
                  _: 1
                })
              ]),
              _: 1
            }, 8, ["modelValue"])
          ]),
          _createElementVNode("div", _hoisted_198, [
            _createVNode(_component_file_upload, {
              id: 'topography-right-upload',
              onFilesChanged: _cache[107] || (_cache[107] = (file) => handleEyeClick('Topography', 'Right', file[0]))
            }, {
              default: _withCtx(() => [
                _createVNode(_component_buttonGroup, null, {
                  default: _withCtx(() => [
                    _createVNode(_component_text_item, {
                      txt: _unref(t)('patient.ophtalmo.current'),
                      class: "txt-primary"
                    }, null, 8, ["txt"]),
                    _createElementVNode("div", _hoisted_199, [
                      _createVNode(_component_svg_item, {
                        icon: "plus",
                        styles: "size-s",
                        class: "img-primary"
                      })
                    ])
                  ]),
                  _: 1
                })
              ]),
              _: 1
            })
          ])
        ]),
        _cache[169] || (_cache[169] = _createElementVNode("div", null, null, -1)),
        _createElementVNode("div", _hoisted_200, [
          _createElementVNode("div", _hoisted_201, [
            _createVNode(_component_file_upload, {
              id: 'topography-left-upload',
              onFilesChanged: _cache[108] || (_cache[108] = (file) => handleEyeClick('Topography', 'Left', file[0]))
            }, {
              default: _withCtx(() => [
                _createVNode(_component_buttonGroup, null, {
                  default: _withCtx(() => [
                    _createVNode(_component_text_item, {
                      txt: _unref(t)('patient.ophtalmo.current'),
                      class: "txt-primary"
                    }, null, 8, ["txt"]),
                    _createElementVNode("div", _hoisted_202, [
                      _createVNode(_component_svg_item, {
                        icon: "plus",
                        styles: "size-s",
                        class: "img-primary"
                      })
                    ])
                  ]),
                  _: 1
                })
              ]),
              _: 1
            })
          ]),
          _createElementVNode("div", _hoisted_203, [
            _createVNode(_component_dropdownBox, {
              modelValue: dropd.value,
              "onUpdate:modelValue": _cache[109] || (_cache[109] = ($event: any) => ((dropd).value = $event)),
              openOn: "topographyLeftHistory"
            }, {
              dropd: _withCtx(() => [
                _createElementVNode("div", _hoisted_204, [
                  _createVNode(_component_dbGroup, null, {
                    default: _withCtx(() => [
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(getHistory('topographyLeft'), (item) => {
                        return (_openBlock(), _createBlock(_component_list_group, {
                          key: item.expression_CclId,
                          styles: "pad-s",
                          onClick: ($event: any) => (selectHistoryItem('topographyLeft', item))
                        }, {
                          default: _withCtx(() => [
                            _createVNode(_component_text_item, {
                              txt: formatHistoryDate(item.date)
                            }, null, 8, ["txt"])
                          ]),
                          _: 2
                        }, 1032, ["onClick"]))
                      }), 128)),
                      (!hasHistory('topographyLeft'))
                        ? (_openBlock(), _createElementBlock("div", _hoisted_205, _toDisplayString(_unref(t)('patient.ophtalmo.noHistory')), 1))
                        : _createCommentVNode("", true)
                    ]),
                    _: 1
                  })
                ])
              ]),
              default: _withCtx(() => [
                _createVNode(_component_buttonGroup, { theme: "dropdown" }, {
                  default: _withCtx(() => [
                    _createVNode(_component_text_item, {
                      txt: getPreviousLabel('topographyLeft'),
                      class: "txt-primary"
                    }, null, 8, ["txt"])
                  ]),
                  _: 1
                })
              ]),
              _: 1
            }, 8, ["modelValue"])
          ])
        ]),
        _createElementVNode("div", _hoisted_206, _toDisplayString(_unref(t)('patient.ophtalmo.topography')), 1),
        _createElementVNode("div", _hoisted_207, [
          _createElementVNode("div", {
            class: _normalizeClass(["image-container", { 'clickable': imageUrls.value.topographyRightPrevious }]),
            onClick: _cache[110] || (_cache[110] = ($event: any) => (imageUrls.value.topographyRightPrevious && openComparisonViewer('topographyRightCurrent', 'topographyRightPrevious')))
          }, [
            (imageUrls.value.topographyRightPrevious)
              ? (_openBlock(), _createElementBlock("img", {
                  key: 0,
                  src: imageUrls.value.topographyRightPrevious,
                  alt: `${_unref(t)('patient.ophtalmo.topography')} ${_unref(t)('patient.ophtalmo.od')} ${_unref(t)('patient.ophtalmo.previous')}`,
                  class: "eye-image"
                }, null, 8, _hoisted_208))
              : (_openBlock(), _createElementBlock("span", _hoisted_209, _toDisplayString(_unref(t)('patient.ophtalmo.previous')), 1))
          ], 2),
          _createElementVNode("div", {
            class: _normalizeClass(["image-container", { 'clickable': imageUrls.value.topographyRightCurrent }]),
            onClick: _cache[111] || (_cache[111] = ($event: any) => (imageUrls.value.topographyRightCurrent && openComparisonViewer('topographyRightCurrent', 'topographyRightPrevious')))
          }, [
            (imageUrls.value.topographyRightCurrent)
              ? (_openBlock(), _createElementBlock("img", {
                  key: 0,
                  src: imageUrls.value.topographyRightCurrent,
                  alt: `${_unref(t)('patient.ophtalmo.topography')} ${_unref(t)('patient.ophtalmo.od')} ${_unref(t)('patient.ophtalmo.current')}`,
                  class: "eye-image"
                }, null, 8, _hoisted_210))
              : (_openBlock(), _createElementBlock("span", _hoisted_211, _toDisplayString(_unref(t)('patient.ophtalmo.current')), 1))
          ], 2)
        ]),
        _cache[170] || (_cache[170] = _createElementVNode("div", null, null, -1)),
        _createElementVNode("div", _hoisted_212, [
          _createElementVNode("div", {
            class: _normalizeClass(["image-container", { 'clickable': imageUrls.value.topographyLeftCurrent }]),
            onClick: _cache[112] || (_cache[112] = ($event: any) => (imageUrls.value.topographyLeftCurrent && openComparisonViewer('topographyLeftCurrent', 'topographyLeftPrevious')))
          }, [
            (imageUrls.value.topographyLeftCurrent)
              ? (_openBlock(), _createElementBlock("img", {
                  key: 0,
                  src: imageUrls.value.topographyLeftCurrent,
                  alt: `${_unref(t)('patient.ophtalmo.topography')} ${_unref(t)('patient.ophtalmo.os')} ${_unref(t)('patient.ophtalmo.current')}`,
                  class: "eye-image"
                }, null, 8, _hoisted_213))
              : (_openBlock(), _createElementBlock("span", _hoisted_214, _toDisplayString(_unref(t)('patient.ophtalmo.current')), 1))
          ], 2),
          _createElementVNode("div", {
            class: _normalizeClass(["image-container", { 'clickable': imageUrls.value.topographyLeftPrevious }]),
            onClick: _cache[113] || (_cache[113] = ($event: any) => (imageUrls.value.topographyLeftPrevious && openComparisonViewer('topographyLeftCurrent', 'topographyPrevious')))
          }, [
            (imageUrls.value.topographyLeftPrevious)
              ? (_openBlock(), _createElementBlock("img", {
                  key: 0,
                  src: imageUrls.value.topographyLeftPrevious,
                  alt: `${_unref(t)('patient.ophtalmo.topography')} ${_unref(t)('patient.ophtalmo.os')} ${_unref(t)('patient.ophtalmo.previous')}`,
                  class: "eye-image"
                }, null, 8, _hoisted_215))
              : (_openBlock(), _createElementBlock("span", _hoisted_216, _toDisplayString(_unref(t)('patient.ophtalmo.previous')), 1))
          ], 2)
        ]),
        _cache[171] || (_cache[171] = _createElementVNode("div", { class: "vertical-spacer" }, null, -1)),
        _cache[172] || (_cache[172] = _createElementVNode("div", { class: "section-label" }, null, -1)),
        _createElementVNode("div", _hoisted_217, [
          _createElementVNode("div", _hoisted_218, [
            _createVNode(_component_dropdownBox, {
              modelValue: dropd.value,
              "onUpdate:modelValue": _cache[114] || (_cache[114] = ($event: any) => ((dropd).value = $event)),
              openOn: "ultrasoundRightHistory"
            }, {
              dropd: _withCtx(() => [
                _createElementVNode("div", _hoisted_219, [
                  _createVNode(_component_dbGroup, null, {
                    default: _withCtx(() => [
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(getHistory('ultrasoundRight'), (item) => {
                        return (_openBlock(), _createBlock(_component_list_group, {
                          key: item.expression_CclId,
                          styles: "pad-s",
                          onClick: ($event: any) => (selectHistoryItem('ultrasoundRight', item))
                        }, {
                          default: _withCtx(() => [
                            _createVNode(_component_text_item, {
                              txt: formatHistoryDate(item.date)
                            }, null, 8, ["txt"])
                          ]),
                          _: 2
                        }, 1032, ["onClick"]))
                      }), 128)),
                      (!hasHistory('ultrasoundRight'))
                        ? (_openBlock(), _createElementBlock("div", _hoisted_220, _toDisplayString(_unref(t)('patient.ophtalmo.noHistory')), 1))
                        : _createCommentVNode("", true)
                    ]),
                    _: 1
                  })
                ])
              ]),
              default: _withCtx(() => [
                _createVNode(_component_buttonGroup, { theme: "dropdown" }, {
                  default: _withCtx(() => [
                    _createVNode(_component_text_item, {
                      txt: getPreviousLabel('ultrasoundRight'),
                      class: "txt-primary"
                    }, null, 8, ["txt"])
                  ]),
                  _: 1
                })
              ]),
              _: 1
            }, 8, ["modelValue"])
          ]),
          _createElementVNode("div", _hoisted_221, [
            _createVNode(_component_file_upload, {
              id: 'ultrasound-right-upload',
              onFilesChanged: _cache[115] || (_cache[115] = (file) => handleEyeClick('Ultrasound', 'Right', file[0]))
            }, {
              default: _withCtx(() => [
                _createVNode(_component_buttonGroup, null, {
                  default: _withCtx(() => [
                    _createVNode(_component_text_item, {
                      txt: _unref(t)('patient.ophtalmo.current'),
                      class: "txt-primary"
                    }, null, 8, ["txt"]),
                    _createElementVNode("div", _hoisted_222, [
                      _createVNode(_component_svg_item, {
                        icon: "plus",
                        styles: "size-s",
                        class: "img-primary"
                      })
                    ])
                  ]),
                  _: 1
                })
              ]),
              _: 1
            })
          ])
        ]),
        _cache[173] || (_cache[173] = _createElementVNode("div", null, null, -1)),
        _createElementVNode("div", _hoisted_223, [
          _createElementVNode("div", _hoisted_224, [
            _createVNode(_component_file_upload, {
              id: 'ultrasound-left-upload',
              onFilesChanged: _cache[116] || (_cache[116] = (file) => handleEyeClick('Ultrasound', 'Left', file[0]))
            }, {
              default: _withCtx(() => [
                _createVNode(_component_buttonGroup, null, {
                  default: _withCtx(() => [
                    _createVNode(_component_text_item, {
                      txt: _unref(t)('patient.ophtalmo.current'),
                      class: "txt-primary"
                    }, null, 8, ["txt"]),
                    _createElementVNode("div", _hoisted_225, [
                      _createVNode(_component_svg_item, {
                        icon: "plus",
                        styles: "size-s",
                        class: "img-primary"
                      })
                    ])
                  ]),
                  _: 1
                })
              ]),
              _: 1
            })
          ]),
          _createElementVNode("div", _hoisted_226, [
            _createVNode(_component_dropdownBox, {
              modelValue: dropd.value,
              "onUpdate:modelValue": _cache[117] || (_cache[117] = ($event: any) => ((dropd).value = $event)),
              openOn: "ultrasoundLeftHistory"
            }, {
              dropd: _withCtx(() => [
                _createElementVNode("div", _hoisted_227, [
                  _createVNode(_component_dbGroup, null, {
                    default: _withCtx(() => [
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(getHistory('ultrasoundLeft'), (item) => {
                        return (_openBlock(), _createBlock(_component_list_group, {
                          key: item.expression_CclId,
                          styles: "pad-s",
                          onClick: ($event: any) => (selectHistoryItem('ultrasoundLeft', item))
                        }, {
                          default: _withCtx(() => [
                            _createVNode(_component_text_item, {
                              txt: formatHistoryDate(item.date)
                            }, null, 8, ["txt"])
                          ]),
                          _: 2
                        }, 1032, ["onClick"]))
                      }), 128)),
                      (!hasHistory('ultrasoundLeft'))
                        ? (_openBlock(), _createElementBlock("div", _hoisted_228, _toDisplayString(_unref(t)('patient.ophtalmo.noHistory')), 1))
                        : _createCommentVNode("", true)
                    ]),
                    _: 1
                  })
                ])
              ]),
              default: _withCtx(() => [
                _createVNode(_component_buttonGroup, { theme: "dropdown" }, {
                  default: _withCtx(() => [
                    _createVNode(_component_text_item, {
                      txt: getPreviousLabel('ultrasoundLeft'),
                      class: "txt-primary"
                    }, null, 8, ["txt"])
                  ]),
                  _: 1
                })
              ]),
              _: 1
            }, 8, ["modelValue"])
          ])
        ]),
        _createElementVNode("div", _hoisted_229, _toDisplayString(_unref(t)('patient.ophtalmo.ultrasound')), 1),
        _createElementVNode("div", _hoisted_230, [
          _createElementVNode("div", {
            class: _normalizeClass(["image-container", { 'clickable': imageUrls.value.ultrasoundRightPrevious }]),
            onClick: _cache[118] || (_cache[118] = ($event: any) => (imageUrls.value.ultrasoundRightPrevious && openComparisonViewer('ultrasoundRightCurrent', 'ultrasoundRightPrevious')))
          }, [
            (imageUrls.value.ultrasoundRightPrevious)
              ? (_openBlock(), _createElementBlock("img", {
                  key: 0,
                  src: imageUrls.value.ultrasoundRightPrevious,
                  alt: `${_unref(t)('patient.ophtalmo.ultrasound')} ${_unref(t)('patient.ophtalmo.od')} ${_unref(t)('patient.ophtalmo.previous')}`,
                  class: "eye-image"
                }, null, 8, _hoisted_231))
              : (_openBlock(), _createElementBlock("span", _hoisted_232, _toDisplayString(_unref(t)('patient.ophtalmo.previous')), 1))
          ], 2),
          _createElementVNode("div", {
            class: _normalizeClass(["image-container", { 'clickable': imageUrls.value.ultrasoundRightCurrent }]),
            onClick: _cache[119] || (_cache[119] = ($event: any) => (imageUrls.value.ultrasoundRightCurrent && openComparisonViewer('ultrasoundRightCurrent', 'ultrasoundRightPrevious')))
          }, [
            (imageUrls.value.ultrasoundRightCurrent)
              ? (_openBlock(), _createElementBlock("img", {
                  key: 0,
                  src: imageUrls.value.ultrasoundRightCurrent,
                  alt: `${_unref(t)('patient.ophtalmo.ultrasound')} ${_unref(t)('patient.ophtalmo.od')} ${_unref(t)('patient.ophtalmo.current')}`,
                  class: "eye-image"
                }, null, 8, _hoisted_233))
              : (_openBlock(), _createElementBlock("span", _hoisted_234, _toDisplayString(_unref(t)('patient.ophtalmo.current')), 1))
          ], 2)
        ]),
        _cache[174] || (_cache[174] = _createElementVNode("div", null, null, -1)),
        _createElementVNode("div", _hoisted_235, [
          _createElementVNode("div", {
            class: _normalizeClass(["image-container", { 'clickable': imageUrls.value.ultrasoundLeftCurrent }]),
            onClick: _cache[120] || (_cache[120] = ($event: any) => (imageUrls.value.ultrasoundLeftCurrent && openComparisonViewer('ultrasoundLeftCurrent', 'ultrasoundLeftPrevious')))
          }, [
            (imageUrls.value.ultrasoundLeftCurrent)
              ? (_openBlock(), _createElementBlock("img", {
                  key: 0,
                  src: imageUrls.value.ultrasoundLeftCurrent,
                  alt: `${_unref(t)('patient.ophtalmo.ultrasound')} ${_unref(t)('patient.ophtalmo.os')} ${_unref(t)('patient.ophtalmo.current')}`,
                  class: "eye-image"
                }, null, 8, _hoisted_236))
              : (_openBlock(), _createElementBlock("span", _hoisted_237, _toDisplayString(_unref(t)('patient.ophtalmo.current')), 1))
          ], 2),
          _createElementVNode("div", {
            class: _normalizeClass(["image-container", { 'clickable': imageUrls.value.ultrasoundLeftPrevious }]),
            onClick: _cache[121] || (_cache[121] = ($event: any) => (imageUrls.value.ultrasoundLeftPrevious && openComparisonViewer('ultrasoundLeftCurrent', 'ultrasoundPrevious')))
          }, [
            (imageUrls.value.ultrasoundLeftPrevious)
              ? (_openBlock(), _createElementBlock("img", {
                  key: 0,
                  src: imageUrls.value.ultrasoundLeftPrevious,
                  alt: `${_unref(t)('patient.ophtalmo.ultrasound')} ${_unref(t)('patient.ophtalmo.os')} ${_unref(t)('patient.ophtalmo.previous')}`,
                  class: "eye-image"
                }, null, 8, _hoisted_238))
              : (_openBlock(), _createElementBlock("span", _hoisted_239, _toDisplayString(_unref(t)('patient.ophtalmo.previous')), 1))
          ], 2)
        ]),
        _cache[175] || (_cache[175] = _createElementVNode("div", { class: "vertical-spacer" }, null, -1)),
        _cache[176] || (_cache[176] = _createElementVNode("div", { class: "section-label" }, null, -1)),
        _createElementVNode("div", _hoisted_240, [
          _createElementVNode("div", _hoisted_241, [
            _createVNode(_component_dropdownBox, {
              modelValue: dropd.value,
              "onUpdate:modelValue": _cache[122] || (_cache[122] = ($event: any) => ((dropd).value = $event)),
              openOn: "biometricsRightHistory"
            }, {
              dropd: _withCtx(() => [
                _createElementVNode("div", _hoisted_242, [
                  _createVNode(_component_dbGroup, null, {
                    default: _withCtx(() => [
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(getHistory('biometricsRight'), (item) => {
                        return (_openBlock(), _createBlock(_component_list_group, {
                          key: item.expression_CclId,
                          styles: "pad-s",
                          onClick: ($event: any) => (selectHistoryItem('biometricsRight', item))
                        }, {
                          default: _withCtx(() => [
                            _createVNode(_component_text_item, {
                              txt: formatHistoryDate(item.date)
                            }, null, 8, ["txt"])
                          ]),
                          _: 2
                        }, 1032, ["onClick"]))
                      }), 128)),
                      (!hasHistory('biometricsRight'))
                        ? (_openBlock(), _createElementBlock("div", _hoisted_243, _toDisplayString(_unref(t)('patient.ophtalmo.noHistory')), 1))
                        : _createCommentVNode("", true)
                    ]),
                    _: 1
                  })
                ])
              ]),
              default: _withCtx(() => [
                _createVNode(_component_buttonGroup, { theme: "dropdown" }, {
                  default: _withCtx(() => [
                    _createVNode(_component_text_item, {
                      txt: getPreviousLabel('biometricsRight'),
                      class: "txt-primary"
                    }, null, 8, ["txt"])
                  ]),
                  _: 1
                })
              ]),
              _: 1
            }, 8, ["modelValue"])
          ]),
          _createElementVNode("div", _hoisted_244, [
            _createVNode(_component_file_upload, {
              id: 'biometrics-right-upload',
              onFilesChanged: _cache[123] || (_cache[123] = (file) => handleEyeClick('Biometrics', 'Right', file[0]))
            }, {
              default: _withCtx(() => [
                _createVNode(_component_buttonGroup, null, {
                  default: _withCtx(() => [
                    _createVNode(_component_text_item, {
                      txt: _unref(t)('patient.ophtalmo.current'),
                      class: "txt-primary"
                    }, null, 8, ["txt"]),
                    _createElementVNode("div", _hoisted_245, [
                      _createVNode(_component_svg_item, {
                        icon: "plus",
                        styles: "size-s",
                        class: "img-primary"
                      })
                    ])
                  ]),
                  _: 1
                })
              ]),
              _: 1
            })
          ])
        ]),
        _cache[177] || (_cache[177] = _createElementVNode("div", null, null, -1)),
        _createElementVNode("div", _hoisted_246, [
          _createElementVNode("div", _hoisted_247, [
            _createVNode(_component_file_upload, {
              id: 'biometrics-left-upload',
              onFilesChanged: _cache[124] || (_cache[124] = (file) => handleEyeClick('Biometrics', 'Left', file[0]))
            }, {
              default: _withCtx(() => [
                _createVNode(_component_buttonGroup, null, {
                  default: _withCtx(() => [
                    _createVNode(_component_text_item, {
                      txt: _unref(t)('patient.ophtalmo.current'),
                      class: "txt-primary"
                    }, null, 8, ["txt"]),
                    _createElementVNode("div", _hoisted_248, [
                      _createVNode(_component_svg_item, {
                        icon: "plus",
                        styles: "size-s",
                        class: "img-primary"
                      })
                    ])
                  ]),
                  _: 1
                })
              ]),
              _: 1
            })
          ]),
          _createElementVNode("div", _hoisted_249, [
            _createVNode(_component_dropdownBox, {
              modelValue: dropd.value,
              "onUpdate:modelValue": _cache[125] || (_cache[125] = ($event: any) => ((dropd).value = $event)),
              openOn: "biometricsLeftHistory"
            }, {
              dropd: _withCtx(() => [
                _createElementVNode("div", _hoisted_250, [
                  _createVNode(_component_dbGroup, null, {
                    default: _withCtx(() => [
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(getHistory('biometricsLeft'), (item) => {
                        return (_openBlock(), _createBlock(_component_list_group, {
                          key: item.expression_CclId,
                          styles: "pad-s",
                          onClick: ($event: any) => (selectHistoryItem('biometricsLeft', item))
                        }, {
                          default: _withCtx(() => [
                            _createVNode(_component_text_item, {
                              txt: formatHistoryDate(item.date)
                            }, null, 8, ["txt"])
                          ]),
                          _: 2
                        }, 1032, ["onClick"]))
                      }), 128)),
                      (!hasHistory('biometricsLeft'))
                        ? (_openBlock(), _createElementBlock("div", _hoisted_251, _toDisplayString(_unref(t)('patient.ophtalmo.noHistory')), 1))
                        : _createCommentVNode("", true)
                    ]),
                    _: 1
                  })
                ])
              ]),
              default: _withCtx(() => [
                _createVNode(_component_buttonGroup, { theme: "dropdown" }, {
                  default: _withCtx(() => [
                    _createVNode(_component_text_item, {
                      txt: getPreviousLabel('biometricsLeft'),
                      class: "txt-primary"
                    }, null, 8, ["txt"])
                  ]),
                  _: 1
                })
              ]),
              _: 1
            }, 8, ["modelValue"])
          ])
        ]),
        _createElementVNode("div", _hoisted_252, _toDisplayString(_unref(t)('patient.ophtalmo.biometrics')), 1),
        _createElementVNode("div", _hoisted_253, [
          _createElementVNode("div", {
            class: _normalizeClass(["image-container", { 'clickable': imageUrls.value.biometricsRightPrevious }]),
            onClick: _cache[126] || (_cache[126] = ($event: any) => (imageUrls.value.biometricsRightPrevious && openComparisonViewer('biometricsRightCurrent', 'biometricsRightPrevious')))
          }, [
            (imageUrls.value.biometricsRightPrevious)
              ? (_openBlock(), _createElementBlock("img", {
                  key: 0,
                  src: imageUrls.value.biometricsRightPrevious,
                  alt: `${_unref(t)('patient.ophtalmo.biometrics')} ${_unref(t)('patient.ophtalmo.od')} ${_unref(t)('patient.ophtalmo.previous')}`,
                  class: "eye-image"
                }, null, 8, _hoisted_254))
              : (_openBlock(), _createElementBlock("span", _hoisted_255, _toDisplayString(_unref(t)('patient.ophtalmo.previous')), 1))
          ], 2),
          _createElementVNode("div", {
            class: _normalizeClass(["image-container", { 'clickable': imageUrls.value.biometricsRightCurrent }]),
            onClick: _cache[127] || (_cache[127] = ($event: any) => (imageUrls.value.biometricsRightCurrent && openComparisonViewer('biometricsRightCurrent', 'biometricsRightPrevious')))
          }, [
            (imageUrls.value.biometricsRightCurrent)
              ? (_openBlock(), _createElementBlock("img", {
                  key: 0,
                  src: imageUrls.value.biometricsRightCurrent,
                  alt: `${_unref(t)('patient.ophtalmo.biometrics')} ${_unref(t)('patient.ophtalmo.od')} ${_unref(t)('patient.ophtalmo.current')}`,
                  class: "eye-image"
                }, null, 8, _hoisted_256))
              : (_openBlock(), _createElementBlock("span", _hoisted_257, _toDisplayString(_unref(t)('patient.ophtalmo.current')), 1))
          ], 2)
        ]),
        _cache[178] || (_cache[178] = _createElementVNode("div", null, null, -1)),
        _createElementVNode("div", _hoisted_258, [
          _createElementVNode("div", {
            class: _normalizeClass(["image-container", { 'clickable': imageUrls.value.biometricsLeftCurrent }]),
            onClick: _cache[128] || (_cache[128] = ($event: any) => (imageUrls.value.biometricsLeftCurrent && openComparisonViewer('biometricsLeftCurrent', 'biometricsLeftPrevious')))
          }, [
            (imageUrls.value.biometricsLeftCurrent)
              ? (_openBlock(), _createElementBlock("img", {
                  key: 0,
                  src: imageUrls.value.biometricsLeftCurrent,
                  alt: `${_unref(t)('patient.ophtalmo.biometrics')} ${_unref(t)('patient.ophtalmo.os')} ${_unref(t)('patient.ophtalmo.current')}`,
                  class: "eye-image"
                }, null, 8, _hoisted_259))
              : (_openBlock(), _createElementBlock("span", _hoisted_260, _toDisplayString(_unref(t)('patient.ophtalmo.current')), 1))
          ], 2),
          _createElementVNode("div", {
            class: _normalizeClass(["image-container", { 'clickable': imageUrls.value.biometricsLeftPrevious }]),
            onClick: _cache[129] || (_cache[129] = ($event: any) => (imageUrls.value.biometricsLeftPrevious && openComparisonViewer('biometricsLeftCurrent', 'biometricsPrevious')))
          }, [
            (imageUrls.value.biometricsLeftPrevious)
              ? (_openBlock(), _createElementBlock("img", {
                  key: 0,
                  src: imageUrls.value.biometricsLeftPrevious,
                  alt: `${_unref(t)('patient.ophtalmo.biometrics')} ${_unref(t)('patient.ophtalmo.os')} ${_unref(t)('patient.ophtalmo.previous')}`,
                  class: "eye-image"
                }, null, 8, _hoisted_261))
              : (_openBlock(), _createElementBlock("span", _hoisted_262, _toDisplayString(_unref(t)('patient.ophtalmo.previous')), 1))
          ], 2)
        ]),
        _cache[179] || (_cache[179] = _createElementVNode("div", { class: "vertical-spacer" }, null, -1))
      ])
    ]),
    _createVNode(imageViewerModal, {
      visible: imageViewerVisible.value,
      image: selectedImage.value,
      "comparison-image": comparisonImage.value,
      onClose: closeImageViewer
    }, null, 8, ["visible", "image", "comparison-image"])
  ], 64))
}
}

})